export default {
    title: {
        KPIDashboard: 'Papan Pemuka KPI',
        GpsTracking: 'Penjejakan GPS',
        EventCalendar: 'Kalendar Acara',
        EventList: 'Senarai Acara',
        Calendar: 'Kalender',
        FullMapTracking: 'Penjejakan Peta Penuh',
        LiveVideo: 'Video Langsung',
        VideoDownloadCenter: 'Pusat Muat Turun Video',
        MultiVehicleTracking: 'Penjejakan Pelbagai Kenderaan',
        VehicleTrackingList: 'Senarai Penjejakan Kenderaan',
        VehicleSummary: 'Ringkasan Kenderaan',
        HistoricalPlayback: 'Main Semula Sejarah',
        HistoricalPlaybackDetails: 'Butiran Main Semula Sejarah',
        PtoLog: 'Log PTO',
        PoiManagement: 'Pengurusan POI',
        AddPOIForm: 'Tambah Borang POI',
        EditPOIForm: 'Edit Borang POI',
        GeofenceManagement: 'Pengurusan Geofence',
        Vehicle: 'Kenderaan',
        ManageVehicle: 'Urus Kenderaan',
        PrintQrs: 'Cetak QR',
        PrintVehicleQrs: 'Cetak QR Kenderaan',
        MaintenanceProfile: 'Profil Penyelenggaraan',
        MaintenanceLog: 'Penyelenggaraan',
        Overview: 'Tinjauan',
        ServiceLog: 'Log Perkhidmatan',
        VehicleLog: 'Log Dokumentasi Kenderaan',
        MaintenanceForm: 'Borang Penyelenggaraan',
        AddMaintenanceForm: 'Tambah Borang Penyelenggaraan',
        EditMaintenanceForm: 'Edit Borang Penyelenggaraan',
        ViewMaintenanceForm: 'Lihat Borang Penyelenggaraan',
        Tools: 'Alat',
        MaintenanceCategory: 'Kategori Penyelenggaraan',
        Driver: 'Pemandu',
        ManageDriver: 'Urus Pemandu',
        ManageDriverForm: 'Borang Pemandu',
        AddDriverForm: 'Tambah Borang Pemandu',
        EditDriverForm: 'Edit Borang Pemandu',
        DriverDetails: 'Butiran Pemandu',
        DriverInquiry: 'Siasatan Pemandu',
        DriverApp: 'Aplikasi Pemandu',
        CheckInOut: 'Daftar Masuk / Keluar',
        ChecklistApproval: 'Kelulusan Senarai Semak',
        DriverClaimReport: 'Laporan Tuntutan Pemandu',
        DriverTracing: 'Penjejakan Pemandu',
        Trailer: 'Treler',
        ManageTrailer: 'Urus Treler',
        AddTrailerForm: 'Tambah Borang Treler',
        EditTrailerForm: 'Edit Borang Treler',
        TrailerTrackingPage: 'Halaman Penjejakan Treler',
        FuelManagement: 'Pengurusan Bahan Api',
        FuelLog: 'Log Bahan Api',
        FuelConsumptionHistory: 'Sejarah Penggunaan Bahan Api',
        RefuelManagement: 'Pengurusan Isi Semula',
        FuelPriceManagement: 'Pengurusan Harga Bahan Api',
        FuelSpend: 'Perbelanjaan Bahan Api',
        FleetAccessSettings: 'Tetapan Akses Armada',
        FleetGroupForm: 'Borang Kumpulan Armada',
        AddFleetGroupForm: 'Tambah Borang Kumpulan Armada',
        EditFleetGroupForm: 'Edit Borang Kumpulan Armada',
        ManageUser: 'Urus Pengguna',
        UserForm: 'Borang Pengguna',
        AddUserForm: 'Tambah Borang Pengguna',
        EditUserForm: 'Edit Borang Pengguna',
        FleetGroupManagement: 'Pengurusan Kumpulan Armada',
        CompanyManagement: 'Pengurusan Syarikat',
        CompanyForm: 'Borang Syarikat',
        AddCompanyForm: 'Tambah Borang Syarikat',
        EditCompanyForm: 'Edit Borang Syarikat',
        EmailNotificationSettings: 'Tetapan Notifikasi E-mel',
        EmailNotificationSettingsForm: 'Borang Tetapan Notifikasi E-mel',
        NotificationSettings: 'Tetepan Notifikasi',
        NotificationSettingsForm: 'Borang Tetapan Notifikasi',
        AddEmailNotificationSettingsForm: 'Tambah Borang Tetapan Notifikasi E-mel',
        EditEmailNotificationSettingsForm: 'Edit Borang Tetapan Notifikasi E-mel',
        RolesManagement: 'Pengurusan Peranan',
        RolesForm: 'Borang Peranan',
        AddRolesForm: 'Tambah Borang Peranan',
        EditRolesForm: 'Edit Borang Peranan',
        PackageManagement: 'Pengurusan Paket',
        PackageForm: 'Borang Paket',
        AddPackageForm: 'Tambah Borang Paket',
        EditPackageForm: 'Edit Borang Paket',
        AuditLogs: 'Log Audit',
        Report: 'Laporan',
        VehicleIndustry: 'Industri Kenderaan',
        VehicleForm: 'Borang Kenderaan',
        AddVehicleForm: 'Tambah Borang Kenderaan',
        EditVehicleForm: 'Edit Borang Kenderaan',
        ManageTracker: 'Urus Penjejak',
        TrackerForm: 'Borang Penjejak',
        AddTrackerForm: 'Tambah Borang Penjejak',
        EditTrackerForm: 'Edit Borang Penjejak',
        MapInstance: 'Instans Peta',
        MapInstanceDetails: 'Butiran Instans Peta',
        UserSettings: 'Tetapan Pengguna',
        UserProfile: 'Profil Pengguna',
        HelpCenter: 'Pusat Bantuan',
        ContactUs: 'Hubungi Kami',
        Documentation: 'Dokumentasi',
        DeviceSettings: 'Tetapan Peranti',
        FirmwareManagement: 'Pengurusan Firmware',
        AlarmHistory: 'Sejarah Penggera',
        AlarmDetails: 'Butiran Penggera',
        Notification: 'Notifikasi',
        Checklist: 'Senarai Semak',
        ManageChecklist: 'Urus Senarai Semak',
        ChecklistTemplate: 'Templat Senarai Semak',
        ManageChecklistForm: 'Borang Senarai Semak',
        AddChecklistForm: 'Tambah Borang Senarai Semak',
        EditChecklistForm: 'Edit Borang Senarai Semak',
        CompanyChecklist: 'Senarai Semak Syarikat',
        BreakdownSupport: 'Penyelesaian Masalah',
        ManageWorkshop: 'Urus Workshop',
        ManageWorkshopForm: 'Borang Workshop',
        AddWorkshopForm: 'Tambah Borang Workshop',
        EditWorkshopForm: 'Edit Borang Workshop',
        ManageWorkshopRating: 'Urus Penilaian Workshop',
        SmartAnalytics: 'Analisis Pintar',
        OperationalPerformance: 'Performa Operasional',
        VehiclePerformance: 'Performa Kenderaan',
        DriverPerformance: 'Performa Pemandu',
        ColdChainMonitoring: 'Monitor Cold Chain',
        Toll: 'Tol',
        ManageToll: 'Urus Tol',
        ManageTollGroup: 'Urus Kumpulan Tol',
        TollGroupForm: 'Borang Kumpulan Tol',
        Insurance: 'Insurans',
        Safety: 'Keselamatan',
        SafetyDashboard: 'Papan Pemuka Keselamatan',
        EventDetails: 'Butiran Peristiwa',
        Speeding: 'Penyelah Kelajuan',
        Route: 'Laluan',
        ManageRoute: 'Urus Laluan',
        ManageRouteDetail: 'Laluan',
        EditManageRouteDetail: 'Edit Laluan',
        ManageRouteGroup: 'Urus Kumpulan Laluan',
        RouteGroupForm: 'Tambah Kumpulan Laluan Baru',
        RouteGroupDetail: 'Route Group',
        AssignRouteGroup: 'Tugaskan Kumpulan Laluan',
        FullMapTrackingLite: 'Penjejakan Peta Penuh',
        RealTimeTrackingGroup: 'Penjejakan Masa Nyata (Kumpulan)',
        VehicleTrackingListLite: 'Senarai Penjejakan Kenderaan',
        ManageRouteForm: 'Urus Borang Laluan',
        ManageLite: 'Urus Lite',
        LiteUserForm: 'Borang Pengguna Lite',
        AddLiteUserForm: 'Tambah Borang Pengguna Lite',
        EditLiteUserForm: 'Edit Borang Pengguna Lite',
        Alert: 'Amaran',
        ServiceRecord: 'Rekod Perkhidmatan',
        CreateNewServiceRecord: 'Cipta Rekod Perkhidmatan Baharu',
        EditServiceRecord: 'Edit Rekod Perkhidmatan',
        ServiceDetails: 'Butiran Perkhidmatan',
        ManagePeripheral: 'Urus Peranti',
        PeripheralDevice: 'Peranti persisian',
        ApiIntegration: 'Integrasi API',
        AddPeripheralDeviceForm: 'Borang Tambah Peranti Periferal',
        EditPeripheralDeviceForm: 'Borang Sunting Peranti Periferal',
        AdvanceSafety: 'Papan Pemuka Keselamatan Lanjutan AI',
        SafetyEvent: 'Acara Keselamatan',
        VehiclePerformanceDetails: 'Butiran Prestasi Kenderaan',
        DriverPerformanceDetails: 'Butiran Prestasi Pemandu',
        Add_Company_Form: 'Borang Tambah Syarikat',
        Edit_Company_Form: 'Edit Borang Syarikat',
        delete_company: "Padam Syarikat",
        CreateNewChecklistTemplate: 'Cipta Templat Senarai Semak Baharu',
        EditChecklistTemplate: 'Edit Templat Senarai Semak',
        DriverCareDashboard: 'Papan Pemuka Driver Care+',
        DriverCare: 'Driver Care+',
        SafetyMonitoring: 'Pemantauan Keselamatan',
        AiSafetyMonitoring: 'Pemantauan Keselamatan AI',
        AddDriverConfiguration: 'Tambah Konfigurasi Pemandu',
        EditDriverConfiguration: 'Edit Konfigurasi Pemandu',
        ChecklistItem: 'Item Senarai Semak',
        DriverConfiguration: 'Konfigurasi Pemandu',
        ManageSuppliers: 'Kelola Penyedia',
        ViewDriverConfiguration: 'Lihat Konfigurasi Pemandu',
        ManageItemCode: 'Kelola Kode Item',
        ManageCheckpoint: 'Uruskan Pusat Pemeriksaan',
        ManageSharableLinkList: 'Urus Senarai Pautan Boleh Dikongsi',
        CreateRefuelRecord: 'Cipta Rekod Isian Minyak',
        EditRefuelRecord: 'Edit Rekod Isian Minyak',
        RefuelImport: 'Import Isian Minyak',
        FuelSpendDriverDetail: 'Perincian Perbelanjaan Minyak Pemandu',
        FuelSpendVehicleDetail: 'Perincian Perbelanjaan Minyak Kenderaan',
        FuelSpendDriver: 'Perbelanjaan Minyak (Pemandu)',
        FuelSpendVehicle: 'Perbelanjaan Minyak (Kenderaan)',
        TwoFactorAuthentication_2FA: 'Otentikasi Dua Faktor (2FA)',
        VideoHistoricalPlayback: 'Main Semula Sejarah Video',
        GreenFleetDashboard: 'Dasbor Green Fleet',
        InternalCombustionEngineVehicles: 'Kenderaan Mesin Mesin Api Internal',
        APIKeyManagement: 'Pengurusan Kunci API',
        VideoReplay: 'Video Replay',
        Trips: 'Trips',
        FuelCalibrationForm: 'Borang Kalibrasi Minyak',
        UserManual: 'Panduan Pengguna',
        IotConfigurator: 'Konfigurator IOT',
        MonitoringBoard: 'Papan Pemantauan',
        DeviceManager: 'Pengurus Peranti',
        PredictiveMaint: 'Penyelenggaraan Prediktif',
        RulesEngine: 'Mesin Aturan',
        RemoteConfig: 'Konfigurasi Jauh',
        AccidentReconstructionDashboard: 'Papan Pemuka Reconstruction Accident',
        AccidentReconstructionDetails: 'Butiran Reconstruction Accident',
        IVMSParameters: 'Parameters IVMS',
        DrivingHour: 'Jam Memandu',
        VehicleDiagnosis: 'Diagnosis Kenderaan',
        AdvanceRoute: 'Laluan Lanjutan',
        TripDetail: 'Butiran Perjalanan',
    },
    genderType: {
        MALE: 'Lelaki',
        FEMALE: 'Perempuan',
        male: 'Lelaki',
        female: 'Perempuan',
        3: 'Tidak Mahu Nyatakan'
    },
    employmentStatus: {
        1: 'Aktif',
    },
    driverType: {
        DIRECT: 'Pemandu Langsung',
        FEEDER: 'Pemandu Feeder'
    },
    approvalStatus: {
        1: 'Diluluskan',
        2: 'Ditolak',
        3: 'Tertangguh'
    },
    serviceType: {
        1: 'Biasa',
        2: 'Segera',
        3: 'Waranti',
        4: 'Servis',
        5: 'Penyelesaian Masalah',
        6: 'Puspakom',
        7: 'Kemalangan',
        8: 'Hilang Sepenuhnya',
        9: 'Overhaul Enjin',
        10: 'Tayar',
        11: 'Servis + Puspakom'
    },
    rateStatus: {
        1: 'Cemerlang',
        2: 'Baik',
        3: 'Boleh Diterima'
    },
    portable: 'Boleh Alih',
    portableType: {
        0: 'Umum',
        1: 'Peranti Mudah Alih',
        2: 'Terikat Treler'
    },
    vehicleStatus: {
        null: 'Beroperasi',
        parking: 'Parkir',
        accident: 'Kemalangan',
        deviceNotOnline: 'Peranti Tidak Dalam Talian',
        repair: 'Baik Pulih',
        immobilized: 'Tidak Bergerak',
        suspendedSim: 'Ditangguhkan (SIM)'
    },
    integrationType: {
        vehicle: 'Kenderaan',
        user: 'Pengguna',
        group: 'Kumpulan Armada'
    },
    faq: {
        dashboard_question_1: "Apakah itu Papan Pemuka KPI?",
        dashboard_answer_1: "Papan Pemuka KPI membolehkan pengguna mendapatkan maklumat ringkas tentang kenderaan dan pemandu. Maklumat yang tersedia di halaman ini termasuk Bil. Kenderaan Aktif Hari Ini, Amaran Penyelenggaraan, Aktiviti Mencurigakan, Bil. Amaran, Carta Penggunaan Harian Kenderaan, Penggunaan Minyak & Jarak Perjalanan, Senarai 5 Teratas Masa Melahu, Penggunaan Bahan Api, dan Kelajuan Tinggi.",
        dashboard_question_2: "Apakah maklumat yang dipaparkan dalam 'Bil. Kenderaan Aktif Hari Ini'?",
        dashboard_answer_2: "'Bil. Kenderaan Aktif Hari Ini' menunjukkan jumlah kenderaan aktif hari ini daripada jumlah keseluruhan kenderaan yang didaftarkan dalam sistem. Dalam paparan terperinci, akan ada senarai kenderaan aktif termasuk nombor plat dan jarak perjalanan kenderaan.",
        dashboard_question_3: "Apakah maklumat yang dipaparkan dalam 'Aktiviti Mencurigakan'?",
        dashboard_answer_3: "'Aktiviti Mencurigakan' memaparkan butiran aktiviti mencurigakan yang dikesan pada kenderaan. Aktiviti mencurigakan ini boleh diberikan kepada pengguna atau kakitangan lain melalui alamat e-mel.",
        dashboard_question_4: "Apakah maklumat yang dipaparkan dalam 'Amaran Penyelenggaraan'?",
        dashboard_answer_4: "'Amaran Penyelenggaraan' memaparkan butiran penyelenggaraan kenderaan yang akan datang. Amaran ini boleh diberikan kepada pengguna atau kakitangan lain melalui alamat e-mel.",
        dashboard_question_5: "Bagaimana Untuk Menukar Jangka Masa Laporan Papan Pemuka KPI?",
        dashboard_answer_5: "Untuk menukar tempoh masa laporan Papan Pemuka KPI, klik pada senarai pilihan 'Semalam' dan pilih jangka masa dari 'Semalam', '7 Hari Lalu', 'Minggu Ini', '30 Hari Lalu', dan 'Bulan Ini', kemudian tekan butang 'Cari' di sebelah kanan.",
        event_calendar_question_1: "Apakah itu Kalendar Acara?",
        event_calendar_answer_1: "Kalendar Acara merangkum tarikh luput seperti insurans, permit, cukai jalan, dan sebagainya dalam bentuk kalendar. Ia menyediakan pandangan yang lebih ringkas untuk membantu pengguna mengesan acara yang akan datang dengan lebih mudah.",
        event_calendar_question_2: "Di mana Saya Boleh Mendapatkan Butiran Acara?",
        event_calendar_answer_2: "Untuk mendapatkan butiran acara, klik pada acara tersebut dan ia akan memaparkan senarai kenderaan yang terlibat dalam acara itu. Klik pada nombor kenderaan akan membawa anda ke butiran kenderaan tersebut.",
        gps_tracking_question_1: "Di Mana Lokasi Semasa Kenderaan?",
        gps_tracking_answer_1: "Pergi ke 'Penjejakan GPS' > 'Senarai Penjejakan Kenderaan'. Pilih dan klik nombor pendaftaran kenderaan untuk menjejak kenderaan dari senarai.",
        gps_tracking_question_2: "Bagaimana Untuk Menjejak Pelbagai Kenderaan Dalam Satu Halaman?",
        gps_tracking_answer_2: "Pergi ke 'Penjejakan GPS' > 'Penjejakan Pelbagai Kenderaan'. Pilih nombor pendaftaran kenderaan untuk menjejak kenderaan dari senarai pilihan. Pengguna boleh menjejak sehingga 4 kenderaan dalam satu halaman.",
        gps_tracking_question_3: "Bagaimana Untuk Menapis Kenderaan Mengikut Kumpulan?",
        gps_tracking_answer_3: "Untuk menapis kenderaan mengikut kumpulan, tekan senarai pilihan '-Sila pilih kumpulan-'. Pilih kumpulan dan tekan 'Cari' di sebelah kanan untuk memproses penapisan.",
        gps_tracking_question_4: "Bagaimana Untuk Mencari Lokasi Koordinat atau Alamat?",
        gps_tracking_answer_4: "Untuk mencari lokasi koordinat atau alamat, klik pada alamat atau koordinat tersebut. Lokasi akan dipaparkan dalam Peta Google.",
        gps_tracking_question_5: "Di Mana Saya Boleh Menjejak Semua Kenderaan Yang Didaftarkan?",
        gps_tracking_answer_5: "Semua kenderaan yang tersedia boleh dijejak dengan pergi ke 'Penjejakan GPS' > 'Peta Penjejakan Penuh Kenderaan'.",
        gps_tracking_question_6: "Bagaimana Untuk Melihat Perjalanan Penuh Kenderaan Dalam Sehari?",
        gps_tracking_answer_6: "Pergi ke 'Penjejakan GPS' > 'Main Semula Sejarah' dan pilih nombor pendaftaran kenderaan untuk dijejak. Seterusnya, pilih tarikh, masa, dan kelajuan main semula yang diingini sebelum klik butang 'Cari'. Selepas main semula dimulakan, klik 'Jalur Penuh' pada panel kanan untuk memaparkan jalur penuh.",
        vehicle_question_1: "Di Mana dan Bagaimana Menambah Kenderaan Baru?",
        vehicle_answer_1: "Pergi ke 'Kenderaan' > 'Tambah Kenderaan Baru', masukkan maklumat yang diperlukan dalam borang dan tekan 'Hantar'.",
        vehicle_question_2: "Di Mana dan Bagaimana Untuk Mengurus Kenderaan?",
        vehicle_answer_2: "Pergi ke 'Kenderaan' > 'Urus Kenderaan', pilih kenderaan untuk diedit. Masukkan maklumat yang dikemas kini ke dalam borang dan tekan 'Simpan'.",
        vehicle_question_3: "Di Mana Saya Boleh Mendapatkan Log Penyelenggaraan Kenderaan?",
        vehicle_answer_3: "Pergi ke 'Kenderaan' > 'Log Penyelenggaraan Kenderaan', semua maklumat kenderaan akan disenaraikan dalam jadual.",
        vehicle_question_4: "Di Mana Saya Boleh Muat Turun/Cetak Log Penyelenggaraan Kenderaan?",
        vehicle_answer_4: "Pergi ke 'Kenderaan' > 'Log Penyelenggaraan Kenderaan', di sudut kanan atas akan terdapat format 'CSV', 'Excel', 'PDF' yang tersedia untuk muat turun dan 'Cetak' untuk mencetak Log Penyelenggaraan Kenderaan.",
        driver_question_1: "Di Mana dan Bagaimana Menambah Pemandu Baru?",
        driver_answer_1: "Pergi ke 'Pemandu' > 'Tambah Pemandu Baru', masukkan maklumat yang diperlukan dalam borang dan tekan 'Hantar'.",
        driver_question_2: "Di Mana dan Bagaimana Untuk Mengurus Pemandu?",
        driver_answer_2: "Pergi ke 'Pemandu' > 'Urus Pemandu', pilih pemandu untuk diedit dan tekan 'Edit Profil' di sudut kanan atas. Masukkan maklumat yang dikemas kini ke dalam borang dan tekan 'Simpan'.",
        driver_question_3: "Di Mana Saya Boleh Mendapatkan Log Pemandu?",
        driver_answer_3: "Pergi ke 'Pemandu' > 'Log Pemandu', maklumat akan disenaraikan dalam jadual.",
        fleet_access_setting_question_1: "Di Mana Untuk Menambah dan Mengurus Pengguna serta Kumpulan Armada?",
        fleet_access_setting_answer_1: "Pergi ke 'Tetapan Akses Armada' dan pergi ke pengurusan kumpulan pengguna tertentu. Kemudian pilih untuk Menambah atau Mengurus kumpulan pengguna tersebut. Ikuti arahan dan isi butiran yang diperlukan.",
        fuel_management_question_1: "Di Mana Saya Boleh Menyemak Laporan Penggunaan Bahan Api Kenderaan?",
        fuel_management_answer_1: "Pergi ke 'Pengurusan Bahan Api' > 'Laporan Penggunaan Bahan Api', pilih kenderaan dan tekan 'Cari'. Semua maklumat penggunaan bahan api kenderaan akan dipaparkan dalam jadual di bawah.",
        fuel_management_question_2: "Di Mana Saya Boleh Menyemak Laporan Isi Semula Bahan Api Kenderaan?",
        fuel_management_answer_2: "Pergi ke 'Pengurusan Bahan Api' > 'Laporan Isi Semula', jadual di bawah akan menyenaraikan butiran isi semula kenderaan, disusun mengikut yang terbaru secara lalai.",
        fuel_management_question_3: "Bagaimana Untuk Memperincikan Laporan Isi Semula Untuk Kenderaan Tertentu?",
        fuel_management_answer_3: "Pergi ke 'Pengurusan Bahan Api' > 'Laporan Isi Semula', pilih nombor pendaftaran kenderaan dan jangka masa tertentu kemudian tekan butang 'Cari'. Jadual di bawah akan menunjukkan semua maklumat isi semula kenderaan dalam tempoh masa tertentu.",
        report_question_1: "Bagaimana Untuk Memuat Turun Laporan?",
        report_answer_1: "Laporan boleh dimuat turun dengan menekan 'Eksport' atau 'Eksport Laporan Penuh' di sudut kanan atas paparan. Secara lalai, laporan adalah dalam format excel.",
        report_question_2: "Bagaimana Saya Boleh Memuat Turun Laporan Dalam Format Lain?",
        report_answer_2: "Untuk memuat turun laporan dalam format lain, tekan 'CSV', 'Excel', atau 'PDF' yang dipaparkan di sudut kanan atas butiran laporan.",
        report_question_3: "Bagaimana Saya Boleh Mencetak Laporan?",
        report_answer_3: "Untuk mencetak laporan, tekan 'Cetak' yang dipaparkan di sudut kanan atas butiran laporan.",
    },
    geofenceModule: {
        checkpoint: 'Pemeriksaan',
        checkpointwithoutnotification: 'Pemeriksaan Tanpa Notifikasi',
        prohibited: 'Dilarang',
        inout: 'Masuk/Keluar',
        in: 'Masuk',
        out: 'Keluar',
        color: {
            null: 'Default',
            black: 'Hitam',
            gray: 'Kelabu',
            red: 'Merah',
            crimson: 'Merah Tua',
            blue: 'Biru',
            cyan: 'Sian',
            olive: 'Zaitun',
            green: 'Hijau',
            lime: 'Limau Nipis',
            yellow: 'Kuning',
            orange: 'Oren',
            salmon: 'Salmon',
            purple: 'Ungu',
        }
    },
    title_text: 'Tajuk',
    please_enter_username: 'Sila Masukkan Nama Pengguna',
    please_enter_password: 'Sila Masukkan Kata Laluan',
    login: 'Log Masuk',
    logout: 'Log Keluar',
    switchLang: 'Tukar Bahasa',
    permit_sah: 'Permit Sah',
    minyak_engine: 'Minyak Enjin',
    Jan: 'Januari',
    Feb: 'Februari',
    Mar: 'Mac',
    Apr: 'April',
    May: 'Mei',
    Jun: 'Jun',
    Jul: 'Julai',
    Aug: 'Ogos',
    Sep: 'September',
    Oct: 'Oktober',
    Nov: 'November',
    Dec: 'Disember',
    no_data: 'Tiada Data',
    start_date: 'Tarikh Mula',
    start_time: 'Masa Mula',
    display_start_date: 'Tarikh Mula Paparan',
    display_priority: 'Keutamaan Paparan',
    display_priority_validation: 'Keutamaan paparan mestilah antara 1 hingga 5.',
    priority_increases_with_number_1_to_5: 'Keutamaan meningkat dengan nombor 1 hingga 5',
    end_date: 'Tarikh Tamat',
    display_end_date: 'Tarikh Tamat Paparan',
    end_time: 'Masa Tamat',
    playback_the_track_when_speed: 'Mainkan semula trek apabila kelajuan >=',
    filter: 'Tapis',
    add: 'Tambah',
    new: 'Baru',
    edit: 'Edit',
    toll: 'Tol',
    edit_profile: 'Edit Profil',
    back: 'Kembali',
    cancel: 'Batal',
    cancel_action: 'Batalkan Tindakan',
    delete: 'Padam',
    are_you_sure_delete: 'Adakah anda pasti untuk memadam <b>%{name}</b>',
    are_you_sure_resend_command_for: 'Adakah anda pasti untuk menghantar semula arahan untuk <b>%{name}</b>',
    are_you_sure_resend_all_command: 'Adakah anda pasti untuk menghantar semula semua arahan',
    are_you_sure_cancel_all_command: 'Adakah anda pasti untuk membatalkan semua arahan',
    save: 'Simpan',
    search: 'Cari',
    apply: 'Terapkan',
    clear_all: 'Padam Semua',
    select_all: 'Pilih Semua',
    deselect_all: 'Nyahpilih Semua',
    draft: 'Draf',
    completed: 'Selesai',
    reset: 'Tetap Semula',
    export: 'Eksport',
    export_log: 'Eksport Log',
    exporting_log: 'Mengeksport log...',
    no_driving_record_data: 'Tiada data rekod pemanduan ditemui untuk acara ini.',
    exporting: 'Mengeksport...',
    exporting_please_wait: 'Sila tunggu semasa PDF sedang dijana.',
    column: 'Lajur',
    action: 'Tindakan',
    total: 'Jumlah',
    online: 'Dalam Talian',
    offline: 'Luar Talian',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    deactive: 'Tidak Aktif',
    select_a_group: 'Pilih Kumpulan',
    select_a_vehicle: 'Pilih Kenderaan',
    select_a_vehicle_type: 'Pilih Jenis Kenderaan',
    select_a_engine_type: 'Pilih Jenis Enjin',
    select_a_plate_no: 'Pilih No Plat',
    select_a_toll_name: 'Pilih Nama Tol',
    select_driver: 'Pilih Pemandu',
    toll_name: 'Nama Tol',
    name: 'Nama',
    summary: 'Ringkasan',
    plate_no: 'No Plat',
    date_start: 'Tarikh Mula',
    date_end: 'Tarikh Tamat',
    total_record: 'Jumlah Rekod',
    acc_count: 'Kiraan Acc',
    idling_count: 'Kiraan Melahu',
    not_located_count: 'Kiraan Tidak Terletak',
    blind_area_reupload_count: 'Kiraan Muat Naik Semula Kawasan Buta',
    abnormal_speed_count: 'Kiraan Kelajuan Tidak Biasa',
    abnormal_max_speed: 'Kelajuan Maks Tidak Biasa',
    abnormal_min_speed: 'Kelajuan Min Tidak Biasa',
    plate_no_driver_name: 'No Plat / Nama Pemandu',
    registration_plate_no: 'No Plat Pendaftaran',
    plate_no_label: 'Label No Plat',
    tied_trailer: 'Trailer Berikat',
    driver: 'Pemandu',
    new_driver: 'Pemandu Baru',
    group: 'Kumpulan',
    device_id: 'ID Peranti',
    sim_card_no: 'No Kad SIM',
    card_no: 'No Kad',
    registration_date: 'Tarikh Pendaftaran',
    installation_date: 'Tarikh Pemasangan',
    warranty_installation_date: 'Tarikh Waranti Pemasangan',
    fuel_consumption: 'Penggunaan Bahan Api',
    car_utilization: 'Penggunaan Kereta',
    safety_level: 'Tahap Keselamatan',
    group_name: 'Nama Kumpulan',
    ignition: 'Penghidup Enjin',
    first_drive: 'Pemanduan Pertama',
    pto: 'PTO',
    pto_1_settings: 'Tetapan PTO 1',
    pto_2: 'PTO 2',
    pto_2_settings: 'Tetapan PTO 2',
    compartment_temperature_sensor_position_settings: 'Tetapan Kedudukan Penderia Suhu Petak',
    front_sensor_position: 'Kedudukan Sensor Depan',
    rear_sensor_position: 'Kedudukan Sensor Belakang',
    status_raw: 'Status (Asal)',
    display_to_customer: 'Paparan kepada Pelanggan',
    reverse_invert_display: 'Songsang (Paparan Songsang)',
    when_enabled_status_shown_reversed: 'Apabila didayakan, status yang ditunjukkan kepada pelanggan akan diterbalikkan',
    door_sensor: 'Sensor Pintu',
    door_sensor_2: 'Sensor Pintu 2',
    time: 'Masa',
    idle_duration: 'Tempoh Tertidur',
    speed: 'Kelajuan',
    device_status: 'Status Peranti',
    mdvr_status: 'Status SafeVision',
    no_issue: 'Tiada isu',
    fuel: 'Bahan Api',
    today_mileage: 'Perbatuan Hari Ini',
    address: 'Alamat',
    custom_view: 'Pandangan Tersuai',
    set_stop_duration: 'Tetapkan Tempoh Berhenti',
    full_map: 'Peta Penuh',
    date_time: 'Tarikh Masa',
    fuel_level: 'Tahap Bahan Api',
    acc: 'ACC',
    mileage_km: 'Perbatuan (KM)',
    start_point: 'Titik Mula',
    end_point: 'Titik Tamat',
    starting_mileage: 'Perbatuan Permulaan',
    location: 'Lokasi',
    idling_duration: 'Tempoh Tertidur',
    parking_duration: 'Tempoh Parkir',
    nombor: 'No.',
    daily_summary: 'Ringkasan Harian',
    live_tracking: 'Penjejakan Langsung',
    view_profile: 'Lihat Profil',
    fuel_report: 'Laporan Bahan Api',
    pto_log: 'Log PTO',
    maintenance_log: 'Log Penyelenggaraan',
    stop_recover_engine: 'Berhenti Pulihkan Enjin',
    assign_unassign_driver: 'Tugaskan/Nyah Tugas Pemandu',
    assign_unassign_tng_card: 'Tugaskan/Nyah Tugas Kad TNG',
    create_sharable_view: 'Cipta Pandangan Berkongsi',
    live_video: 'Video Langsung',
    status: 'Status',
    engine_type: 'Jenis Enjin',
    vehicle_type: 'Jenis Kenderaan',
    normal: 'Normal',
    idling: 'Berteduh',
    parking: 'Parkir',
    contact: 'Hubungi',
    phone_no: 'No Telefon',
    vehicle: 'Kenderaan',
    poi: 'POI',
    traffic: 'Trafik',
    geofence: 'Geofence',
    search_by_plate_no: 'Cari mengikut No Plat',
    search_by_poi: 'Cari mengikut Nama POI',
    search_by_checkpoint: 'Carian mengikut pusat pemeriksaan',
    search_by_geofence: 'Cari mengikut Nama Geofence',
    all: 'Semua',
    moving: 'Bergerak',
    disconnected: 'Terputus',
    geofence_entry_ot: 'Geofence Masuk OT',
    speeding: 'Memandu laju',
    ICE: 'Enjin Pembakaran Dalaman (ICE)',
    PHEV: 'Kenderaan Elektrik Hibrid Palam (PHEV)',
    EV: 'Kenderaan Elektrik (EV)',
    car: 'Kereta',
    bus: 'Bas',
    truck: 'Lori',
    machinery: 'Jentera',
    machinery_crane: 'Jentera Kren',
    mixer: 'Lori Pengadun',
    van: 'Van',
    crane: 'Kren',
    motor: 'Motosikal',
    strong: 'Kuat',
    medium: 'Sederhana',
    weak: 'Lemah',
    healthy: 'Sihat',
    aware: 'Berjaga-jaga',
    abnormal: 'Tidak Normal',
    'open circuit': 'Litar Terbuka',
    'short circuit': 'Litar Pendek',
    unknown: 'Tidak Diketahui',
    need_replacement: 'Perlu Ganti',
    full_charge: 'Pengecasan Penuh',
    charging: 'Sedang Mengecas',
    low_charge: 'Pengecasan Rendah',
    and_above: 'dan ke atas',
    and_below: 'dan ke bawah',
    engine_service_date: 'Tarikh Servis Enjin',
    transmission_gear_box_service_date: 'Tarikh Servis Transmisi / Kotak Gear',
    electrical_system_service_date: 'Tarikh Servis Sistem Elektrik',
    please_select_vehicle: 'Sila pilih kenderaan terlebih dahulu...',
    please_select_driver: 'Sila pilih pemandu terlebih dahulu...',
    please_select_date: 'Sila pilih tarikh',
    please_select_group_or_vehicle_first: 'Sila pilih kumpulan atau kenderaan terlebih dahulu',
    please_select_filters_first: 'Sila pilih penapis terlebih dahulu',
    show_route: 'Tunjukkan Laluan',
    hide_route: 'Sembunyikan Laluan',
    live_data: 'Data Langsung',
    maintenance: 'Penyelenggaraan',
    add_poi: 'Tambah POI',
    edit_poi: 'Edit POI',
    poi_details: 'Butiran POI',
    poi_name: 'Nama POI',
    poi_latitude: 'Latitud POI',
    poi_longitude: 'Longitud POI',
    poi_icon: 'Ikon POI',
    poi_radius: 'Radius POI',
    poi_contacter: 'Penyambung POI',
    poi_phone: 'Telefon POI',
    poi_address: 'Alamat POI',
    poi_remark: 'Catatan POI',
    checkpoint_name: 'Nama pusat pemeriksaan',
    checkpoint_latitude: 'Latitud pusat pemeriksaan',
    checkpoint_longitude: 'Longitud pusat pemeriksaan',
    checkpoint_radius: 'Jejari pusat pemeriksaan',
    checkpoint_type: 'Jenis Pusat Pemeriksaan',
    base: 'Base',
    station: 'Stesen',
    terminal: 'Terminal',
    checkpoint_remark: 'Kenyataan pusat pemeriksaan',
    total_cost: 'Jumlah Kos',
    total_spend: 'Jumlah Perbelanjaan',
    code: 'Kod',
    description: 'Penerangan',
    maintenance_category: 'Kategori Penyelenggaraan',
    maintenance_form: 'Penyelenggaraan Baharu',
    form_no: 'No. Borang',
    workshop: 'Bengkel',
    contact_no: 'No. Hubungi',
    service_type: 'Jenis Servis',
    cost_of_repair_rm: 'Kos Pembaikan (RM)',
    urgent: 'Acuan',
    warranty: 'Jaminan',
    servicing: 'Penyelenggaraan',
    troubleshooting: 'Penyelesaian Masalah',
    puspakom: 'Puspakom',
    accident: 'Kecelakaan',
    total_lost: 'Jumlah Kerugian',
    engine_overhaul: 'Pembaikan Enjin',
    tyre: 'Tayar',
    maintenance_form_details: 'Butiran Borang Penyelenggaraan',
    repair_maintenance_order: 'Perintah Penyelenggaraan Pembetulan',
    vehicle_condition_remark: 'Catatan Keadaan Kenderaan',
    please_enter: 'Sila masukkan...',
    please_select: 'Sila pilih',
    partnership_workshop: 'Bengkel Perkongsian',
    drive_in_date_time: 'Tarikh / Masa Masuk',
    drive_out_date_time: 'Tarikh / Masa Keluar',
    technician: 'Teknikan',
    drop_off_driver: 'Hantar Pemandu',
    pickup_driver: 'Ambil Pemandu',
    estimate_complete_date: 'Tarikh Anggaran Selesai',
    item: 'Item',
    good: 'Baik',
    front_head_lamps: 'Lampu Hadapan',
    rear_tails_lamps: 'Lampu Belakang',
    adjust_brake_pm_trailer: 'Laraskan Brek PM / Treler',
    brake_pm_trailer: 'Brek PM Treler',
    top_up_engine_oil: 'Tambah Minyak Enjin',
    top_up_aircond_gas: 'Tambah Gas Penyaman Udara',
    rear_front_view_mirror: 'Cermin Pandang Belakang',
    air_leaking: 'Kebocoran Udara',
    windscreen: 'Cermin Depan',
    both_side_windows: 'Tetingkap Sisi Kiri dan Kanan',
    wiring_problem: 'Masalah Pendawaian',
    gear_problem: 'Masalah Gear',
    wiper_blade: 'Bilah Penyapu',
    permit_date: 'Tarikh Permit',
    roadtax_date: 'Tarikh Cukai Jalan',
    sgp_roadtax_date: 'Tarikh Cukai Jalan SGP',
    puspakom_date: 'Tarikh Puspakom',
    insurance_date: 'Tarikh Insurans',
    service_date: 'Tarikh Servis',
    service_due_date: 'Tarikh Jatuh Servis',
    remaining_mileage: 'Jarak Perjalanan Tersisa',
    service_log: 'Log Servis',
    vehicle_log: 'Log Kenderaan',
    view_all: 'Lihat Semua',
    category: 'Kategori',
    type: 'Jenis',
    last_service_mileage: 'Jarak Servis Terakhir',
    next_date: 'Tarikh Seterusnya',
    current_mileage: 'Jarak Mampu',
    affordable_mileage: 'Jarak Mampu',
    spare_part_cost: 'Kos Alat Ganti',
    labour_cost: 'Kos Buruh',
    supplier: 'Pembekal',
    service: 'Servis',
    last_service_date: 'Tarikh Servis Terakhir',
    remark: 'Catatan',
    service_details: 'Butiran Servis',
    mark_as_done: 'Tandakan Sebagai Selesai',
    details: 'Butiran',
    history: 'Sejarah',
    categories: 'Kategori',
    maintenance_type: 'Jenis Penyelenggaraan',
    date: 'Tarikh',
    spare_cost: 'Kos Alat Ganti',
    payment_date: 'Tarikh Pembayaran',
    driver_name: 'Nama Pemandu',
    license_no: 'No. Lesen',
    license_expiry_date: 'Tarikh Tamat Tempoh Lesen',
    psv_expiry_date: 'Tarikh Tamat PSV',
    permit_expiry_date: 'Tarikh Tamat Permit',
    gdl_expiry_date: 'Tarikh Tamat GDL',
    company: 'Syarikat',
    created_by: 'Dicipta Oleh',
    created_at: 'Dicipta Pada',
    last_updated: 'Dikemas Kini Terakhir',
    last_updated_at: 'Dikemas Kini Pada %{time}',
    last_location: 'Lokasi Terakhir',
    check_in_time: 'Masa Daftar Masuk',
    check_out_list: 'Senarai Daftar Keluar',
    driver_list: 'Senarai Pemandu',
    all_driver_list: 'Senarai Semua Pemandu',
    driver_type: 'Jenis Pemandu',
    check_in_date_time: 'Tarikh / Masa Daftar Masuk',
    check_out_date_time: 'Tarikh / Masa Daftar Keluar',
    forced_check_out: 'Daftar Keluar Paksa',
    checklist_no: 'No. Senarai Semak',
    today_checked_in: 'Hari Ini Daftar Masuk',
    today_checked_out: 'Hari Ini Daftar Keluar',
    checked_in: 'Telah Daftar Masuk',
    checked_out: 'Telah Daftar Keluar',
    last_7_days: '7 Hari Terakhir',
    today_total_checklist: 'Jumlah Senarai Semak Hari Ini',
    driver_without_checklist: 'Pemandu Tanpa Senarai Semak',
    vehicle_without_checklist: 'Kenderaan Tanpa Senarai Semak',
    failed_item_no: 'No. Item Gagal',
    verify_by: 'Sahkan Oleh',
    verify_at: 'Sahkan Pada',
    verify: 'Sahkan',
    driver_claim_overview: 'Gambaran Keseluruhan Tuntutan Pemandu',
    last_30_days: '30 Hari Terakhir',
    total_claim: 'Jumlah Tuntutan',
    total_petrol_claim: 'Jumlah Tuntutan Petrol',
    toll_claim: 'Tuntutan Tol',
    total_toll_claim: 'Jumlah Tuntutan Tol',
    total_number_of_driver: 'Jumlah Pemandu',
    petrol_claim: 'Tuntutan Petrol',
    petrol_toll_claim: 'Tuntutan Petrol dan Tol',
    today: 'Hari Ini',
    yesterday: 'Semalam',
    last_week: 'Minggu Lepas',
    last_month: 'Bulan Lepas',
    weekly: 'Mingguan',
    monthly: 'Bulanan',
    yearly: 'Tahunan',
    driver_claim_history: 'Sejarah Tuntutan Pemandu',
    toll_claim_rm: 'Tuntutan Tol (RM)',
    petrol_claim_rm: 'Tuntutan Petrol (RM)',
    total_cost_rm: 'Jumlah Kos (RM)',
    driver_claim_profile: 'Profil Tuntutan Pemandu',
    claim_date: 'Tarikh Tuntutan',
    reviewed_by: 'Disemak Oleh',
    reviewed_date: 'Tarikh Disemak',
    attachment: 'Lampiran',
    attachments: 'Lampiran-lampiran',
    review: 'Semak',
    reject: 'Tolak',
    approve: 'Luluskan',
    point_to_point_distance: 'Jarak Titik ke Titik',
    point: 'Titik',
    add_point: 'Tambah Titik',
    calculate: 'Kira',
    duration: 'Tempoh',
    pto_status: 'Status PTO',
    on: 'Hidup',
    off: 'Mati',
    on_cap: 'HIDUP',
    off_cap: 'MATI',
    index: 'Indeks',
    geofence_instance_name: 'Nama Instans Geofence',
    number_of_geofence: 'Bilangan Geofence',
    creator: 'Pencipta',
    manage: 'Urus',
    device_integration: 'Integrasi Peranti',
    geofence_details: 'Butiran Geofence',
    trailer_no: 'No. Treler',
    roadtax_expiry_date: 'Tarikh Tamat Cukai Jalan',
    sgp_roadtax_expiry_date: 'Tarikh Tamat Cukai Jalan SGP',
    sgp_expiry_date: 'Tarikh Tamat SGP',
    "puspakom_expiry_date": "Tarikh Tamat Puspakom",
    "insurance_start_date": "Tarikh Mula Puspakom",
    "insurance_expiry_date": "Tarikh Tamat Insurans",
    "pma_expiry_date": "Tarikh Tamat PMA",
    "trailer": "Treler",
    "trailer_profile": "Profil Treler",
    "trailer_details": "Butiran Treler",
    "roadtax_no": "No. Cukai Jalan",
    "singapore_roadtax_no": "No. Cukai Jalan Singapura",
    "singapore_roadtax_expiry_date": "Tarikh Tamat Cukai Jalan Singapura",
    "puspakom_no": "No. Puspakom",
    "insurance_no": "No. Insurans",
    "pma_no": "No. PMA",
    "insurance_sum_assured_rm": "Jumlah Insurans (RM)",
    "assigned_prime_mover": "Prime Mover Yang Ditetapkan",
    "rfid_no": "No. RFID",
    "total_active_vehicle": "Jumlah Kenderaan Aktif",
    "total_vehicle": "Jumlah Kenderaan",
    "suspicious_activity": "Aktiviti Mencurigakan",
    "maintenance_notification": "Pemberitahuan Penyelenggaraan",
    "no_of_alert": "Jumlah Amaran",
    "expenses": "Perbelanjaan",
    "fuel_usage_mileage": "Penggunaan Minyak & Perjalanan",
    "last_update_on": "Kemaskini Terakhir Pada %{date}",
    "environment_gas_emission": "Emisi Gas Alam Sekitar",
    "table_of_environment_gas_emission": "Jadual Emisi Gas Alam Sekitar",
    "environment_gas_emission_report": "Laporan Emisi Gas Alam Sekitar",
    "month": "Bulan",
    "co2_kg": 'CO<sub>2</sub> (kg)',
    "ch2_gms": 'CH<sub>2</sub> (gms)',
    "so2_gms": 'SO<sub>2</sub> (gms)',
    "no2_gms": 'NO<sub>X</sub> (gms)',
    "pm_gms": "PM (gms)",
    "hc_gms": "HC (gms)",
    "compare_to_last_month": "berbanding dengan bulan lepas",
    "from_previous_month": "dari bulan sebelumnya",
    "total_mileage_km": "Jumlah Perjalanan (km)",
    "total_travel_time": "Jumlah Masa Perjalanan",
    "total_idling_duration": "Jumlah Durasi Menganggur",
    "fuel_economy": "Ekonomi Minyak",
    "chart_of_daily_utilization_of_vehicles": "Carta Penggunaan Harian Kenderaan",
    "summary_report_list": "Senarai Laporan Ringkasan",
    "vehicle_report_list": "Senarai Laporan Kenderaan",
    "driver_report_list": "Senarai Laporan Pemandu",
    "vehicle_active_report": "Laporan Kenderaan Aktif",
    "overall_fleet_fuel_avg_economy": "Purata Ekonomi Minyak Armada Keseluruhan",
    "ok": "Ok",
    "offline_for_1_2_days": "Offline selama 1-2 Hari",
    "offline_for_3_4_days": "Offline selama 3-4 Hari",
    "offline_for_5+_days": "Offline selama 5+ Hari",
    "not_active": "Tidak Aktif",
    "good_0.050km_0.1km_l": "Baik - 0.050km - 0.1km/l",
    "medium_0.050km_0.1km_l": "Sederhana - 0.050km - 0.1km/l",
    "alert_0.050km_0.1km_l": "Amaran - 0.050km - 0.1km/l",
    "top5_idling_time": "Top 5 Masa Menganggur",
    "top5_high_speed": "Top 5 Kelajuan Tinggi",
    "top5_high_fuel_consumption": "Top 5 Penggunaan Minyak Tinggi",
    "top5_fuel_economy": "Top 5 Ekonomi Minyak",
    "driver_score": "Skor Pemandu",
    "average_driver_score": "Skor Purata Pemandu",
    "driver_status": "Status Pemandu",
    "top5_safety_driver": "Top 5 Pemandu Selamat",
    "top5_high_risk_driver": "Top 5 Pemandu Berisiko Tinggi",
    "excellent": "Cemerlang",
    "fair": "Sederhana",
    "critical": "Kritikal",
    "high": "Tinggi",
    "distance_km": "Jarak (km)",
    "active_driver": "Pemandu Aktif",
    "event": "Peristiwa",
    "no_of_vehicles": "Jumlah Kenderaan",
    "utilized_vehicles": "Kenderaan Digunakan",
    "kilometer": "Kilometer",
    "liter": "Liter",
    "fuel_usage": "Penggunaan Minyak",
    "mileage": "Perjalanan",
    "trips": "Perjalanan",
    "vehicle_performance": "Prestasi Kenderaan",
    "driver_app": "Aplikasi Pemandu",
    "advanced_safety": "Keselamatan Lanjutan",
    "safety": "Keselamatan",
    "spend": "Perbelanjaan",
    "operator": "Pengendali",
    "alert": "Amaran",
    "diagnosis": "Diagnosis",
    "all_vehicle_summary_report": "Laporan Ringkasan Semua Kenderaan",
    "monthly_vehicle_mileage_report": "Laporan Perbatuan Kenderaan Bulanan",
    "vehicle_status_log": "Log Status Kenderaan",
    "vehicle_usage_report": "Laporan Penggunaan Kenderaan",
    "trips_report": "Laporan Perjalanan",
    "geofence_report": "Laporan Geofence",
    "poi_report": "Laporan POI",
    "machinery_summary_report": "Laporan Ringkasan Mesin",
    "maintenance_log_report": "Laporan Log Penyelenggaraan",
    "idling_summary_report": "Laporan Ringkasan Menganggur",
    "monthly_idling_summary_report_by_geofence_category": 'Laporan Ringkasan Enjin Hidup Tanpa Bergerak Bulanan mengikut Kategori Geofence',
    "grand_total": "Jumlah Grand Total",
    "raw_data_report": "Laporan Data Mentah",
    "engine_report": "Laporan Enjin",
    "temperature_chart": "Carta Suhu",
    "temperature": "Suhu",
    "pto_camera_report": "Laporan Kamera PTO",
    "rotation_report": "Laporan Putaran",
    "driving_record_report": "Laporan Rekod Pemanduan",
    "speed_evidence_log_report": "Laporan Log Bukti Kelajuan",
    "trailer_log_report": "Laporan Log Treler",
    "trailer_raw_report": "Laporan Mentah Treler",
    "driver_summary_report": "Laporan Ringkasan Pemandu",
    "driver_logs_report": "Laporan Log Pemandu",
    "driver_trips_report": "Laporan Perjalanan Pemandu",
    "driver_activity_report": "Laporan Aktiviti Pemandu",
    "driver_activity_summary_report": "Laporan Ringkasan Aktiviti Pemandu",
    "driver_violation_report": "Laporan Pelanggaran Pemandu",
    "driver_debriefing_report": "Laporan Debriefing Pemandu",
    "driver_trip_summary_report": "Laporan Ringkasan Perjalanan Pemandu",
    "driver_unauthorized_stop_report": "Laporan Hentian Tidak Dibenarkan Pemandu",
    "driver_driving_behaviour_violation_report": "Laporan Pelanggaran Tingkah Laku Pemanduan Pemandu",
    "violation_datetime": "Tarikh & Masa Pelanggaran",
    "violation_duration": "Tempoh Pelanggaran",
    "start_datetime": "Tarikh & Masa Mula",
    "end_datetime": "Tarikh & Masa Tamat",
    "start_location": "Lokasi Mula",
    "end_location": "Lokasi Tamat",
    "drive_time": "Masa memandu",
    "idle_time": "Masa Idle",
    "overspeed": "Kelajuan Berlebihan",
    overspeed_type: 'Jenis Kelajuan Berlebihan',
    "max_speed": "Kelajuan Maks",
    "driver_score_report": "Laporan Skor Pemandu",
    "driver_safety_report": "Laporan Keselamatan Pemandu",
    "driver_safety_behaviour_report": "Laporan Perilaku Keselamatan Pemandu",
    "driver_job_report": "Laporan Pekerjaan Pemandu",
    "get_checklist_report": "Dapatkan Laporan Senarai Semak",
    "vehicle_safety_report": "Laporan Keselamatan Kenderaan",
    "fatigue_photo_video_report": "Laporan Foto Video Keletihan",
    "fatigue_monitor_board": "Papan Pemantauan Keletihan",
    "fatigue_driving_record": "Rekod Pemanduan Keletihan",
    "toll_report": "Laporan Tol",
    "fuel_drop_report": "Laporan Penurunan Minyak",
    "refuel_summary_report": "Laporan Ringkasan Pengisian Semula",
    "mileage_liter_by_statement": "Jarak Perjalanan/Liter Mengikut Pernyataan",
    "operator_company_daily_report": "Laporan Harian Syarikat Pengendali",
    "operator_attendance_report": "Laporan Kehadiran Pengendali",
    "operator_driver_report": "Laporan Pemandu Pengendali",
    "suspicious_activity_report": "Laporan Aktiviti Mencurigakan",
    "critical_alert_report": "Laporan Amaran Kritikal",
    "alert_report": "Laporan Amaran",
    "maintenance_alert_report": "Laporan Amaran Penyelenggaraan",
    "vehicle_diagnosis_report": "Laporan Diagnosis Kenderaan",
    "speed_report": "Laporan Kelajuan",
    "overspeed_record_report": "Laporan Rekod Kelajuan Berlebihan",
    "report": "Laporan",
    "yes": "Ya",
    "no": "Tidak",
    "item_for_inspection": "Item Untuk Pemeriksaan",
    "minyak_power_setting": "Tetapan Kuasa Minyak",
    "recently_viewed": "Lihat Baru-Baru Ini",
    "starred": "Ditanda Bintang",
    "idling_time_min": "Masa Menganggur (Minit)",
    "report_type": "Jenis Laporan",
    "customize_column": "Sesuaikan Ruangan",
    "fleet": "Armada",
    "max_speed_km_h": "Kelajuan Maksimum (KM/J)",
    "fuel_usage_l": "Penggunaan Minyak (L)",
    "fuel_cost_rm": "Kos Minyak (RM)",
    "refuel_amount_l": "Jumlah Pengisian Semula (L)",
    "km_l": "KM/L",
    "fuel_efficiency_perc": "Kecekapan Minyak (%)",
    "fuel_consumption_km_l": "Penggunaan Minyak (KM/L)",
    "total_idle_duration": "Jumlah Durasi Menganggur",
    "unallowed_idle_duration": "Durasi Menganggur Tidak Dibenarkan",
    "idling_fuel_usage_l": "Penggunaan Minyak Menganggur (L)",
    "idle_cost_rm": "Kos Menganggur (RM)",
    "total_driving_duration": "Jumlah Durasi Pemanduan",
    "total_journey_time": "Jumlah Masa Perjalanan",
    "avg_daily_speed_km_h": "Purata Kelajuan Harian (KM/J)",
    "data_summaries": "Ringkasan Data",
    "vehicle_summaries": "Ringkasan Kenderaan",
    "data_details": "Butiran Data",
    "profile_info": "Maklumat Profil",
    "training_record": "Rekod Latihan",
    "violation_record": "Rekod Pelanggaran",
    "driver_detail": "Butiran Pemandu",
    "driver_details": "Butiran Pemandu",
    "staff_id": "ID Staf",
    "tel_no_hp": "No. Tel (hp)",
    "date_of_birth": "Tarikh Lahir",
    "emergency_contact": "Kontak Kecemasan",
    "working_position": "Jawatan Kerja",
    "nric": "NRIC",
    "email": "Emel",
    "gender": "Jantina",
    "password": "Kata Laluan",
    "nationality": "Kewarganegaraan",
    "rental_fee": "Yuran Sewa",
    "other_information": "Maklumat Lain",
    "other_informations": "Maklumat Lain-Lain",
    "driving_license_no": "No. Lesen Memandu",
    "driving_license_expiry_date": "Tarikh Tamat Lesen Memandu",
    "commercial_license_no_gdl": "No. Lesen Komersial (GDL)",
    "comm_license_no_expiry_date": "Tarikh Tamat Lesen Komersial",
    "permit_no": "No. Permit",
    "psv_no": "No. PSV",
    "psv_license_expire": "Tarikh Tamat Lesen PSV",
    "hired_date": "Tarikh Diambil Bekerja",
    "salary": "Gaji",
    "bank": "Bank",
    "bank_acc": "Akaun Bank",
    "bank_acc_no": "No. Akaun Bank",
    "assign_to": "Tugaskan Kepada",
    "employment_status": "Status Pekerjaan",
    "permanent": "Permanen",
    "note": "Nota",
    "ic_license_upload": "Muat Naik IC & Lesen",
    "ic": "IC",
    "driving_license": "Lesen Memandu",
    "comm_license_gdl": "Lesen Komersial (GDL)",
    "training_title": "Tajuk Latihan",
    "attended_date": "Tarikh Hadir",
    "expiry_date": "Tarikh Tamat",
    "cost": "Kos",
    "cost_rm": "Kos (RM)",
    "compulsory": "Wajib",
    "violation_type": "Jenis Pelanggaran",
    "violation_date": "Tarikh Pelanggaran",
    "fine": "Denda",
    "fine_rm": "Denda (RM)",
    "pay_by": "Bayar Mengikut",
    "other_details": "Butiran Lain",
    "driver_apps_credential": "Kredential Aplikasi Driver Care+",
    "pick_your_birthday": "Pilih Tarikh Lahir Anda",
    "male": "Lelaki",
    "female": "Perempuan",
    "next": "Seterusnya",
    "malaysian": "Warganegara Malaysia",
    "non_malaysian": "Bukan Warganegara Malaysia",
    "direct_driver": "Pemandu Langsung",
    "feeder_driver": "Pemandu Feeder",
    "comm_license": "Lesen Komersial",
    "please_ignore_it_if_not_applicable": "* Sila Abaikan Jika Tidak Berkaitan",
    "username": "Nama Pengguna",
    "assign_to_supervisor": "Tugaskan Kepada Penyelia",
    "supervisor": "Penyelia",
    "route_group": "Kumpulan Laluan",
    "route_in_charge": "Laluan Di bawah Tanggungjawab",
    "trip_details": "Butiran Perjalanan",
    "historical_playback": "Main Balik Sejarah",
    "alert_log": "Log Amaran",
    "avg_speed": "Kelajuan Purata",
    "activities": "Aktiviti",
    "driver_distance": "Jarak Pemandu",
    "violation": "Pelanggaran",
    "device_type": "Jenis Peranti",
    "protocol_type": "Jenis Protocol",
    "color": "Warna",
    "manufacturer_model": "Model Pengilang",
    "chasis_no": "No. Chasis",
    "owned_sub_con": "Milikan/Sub-Kontraktor",
    "capacity": "Kapasiti",
    "capacity_unit": "Unit Kapasiti",
    "tng_no": "No. TNG",
    "fleet_card_no": "No. Kad Armada",
    "tank_no": "No. Tangki",
    "electrical_system": "Sistem Elektrik",
    "vehicle_details": "Butiran Kenderaan",
    new_vehicle_industry: 'Industri Kenderaan Baru',
    "vehicle_industry": "Industri Kenderaan",
    "speed_limit_km_h": "Had Kelajuan (km/j)",
    "allowing_idling_time": "Membenarkan Masa Menganggur",
    "operation_hour_per_week_hrs": "Jam Operasi Seminggu (jam)",
    "main_road_condition": "Keadaan Jalan Utama",
    "good_type": "Jenis Baik",
    "estimated_overload_perc": "Anggaran Lebihan Beban (%)",
    "idling_alert_setting": "Tetapan Amaran Menganggur",
    "idling_minutes": "Minit Menganggur",
    "please_leave_blank_for_using_the_default_idling_setting": "* Sila biarkan kosong untuk menggunakan tetapan menganggur lalai",
    "minutes": "Minit",
    "low_fuel_alert_setting": "Tetapan Amaran Minyak Rendah",
    "low_fuel_percentage": "Peratusan Minyak Rendah",
    "please_leave_blank_for_using_the_default_low_fuel_setting": "* Sila biarkan kosong untuk menggunakan tetapan minyak rendah lalai",
    "low_fuel_critical_alert": "Amaran Kritikal Minyak Rendah",
    "fuel_drop_percentage": "Peratusan Penurunan Minyak",
    "please_leave_blank_for_using_the_default_fuel_drop_setting": "* Sila biarkan kosong untuk menggunakan tetapan penurunan minyak lalai",
    "please_leave_blank_for_using_the_default_fuel_efficiency": "* Sila biarkan kosong untuk menggunakan kecekapan minyak lalai",
    "please_leave_blank_for_using_the_default_best_in_class_fuel_efficiency": "* Sila biarkan kosong untuk menggunakan kecekapan bahan api lalai penanda aras unggul",
    "please_leave_blank_for_using_the_default_fuel_waste_rate": "* Sila biarkan kosong untuk menggunakan kadar pembaziran minyak lalai",
    "please_leave_blank_for_using_the_default_minimum_refuel_detection": "* Sila biarkan kosong untuk menggunakan pengesanan pengisian semula minimum lalai",
    "prohibit_driving_periods": "Tempoh Larangan Pemanduan",
    "add_new_prohibit_period": "Tambah Tempoh Larangan Baru",
    remove_all: 'Buang Semua',
    document_due_date_reminder: 'Peringatan Tarikh Akhir Dokumen',
    reminder_date: 'Tarikh Peringatan',
    vehicle_documents: 'Dokumen Kenderaan',
    registration_certificate: 'Sijil Pendaftaran',
    fuel_history: 'Sejarah Bahan Api',
    today_active_inactive_vehicle: 'Kenderaan Aktif & Tidak Aktif Hari Ini',
    distance: 'Jarak',
    maintenance_alert_reminder: 'Peringatan Amaran Penyelenggaraan',
    past_checklist: 'Senarai Semak Lalu',
    today_checklist: 'Senarai Semak Hari Ini',
    section: 'Bahagian',
    na: 'N/A',
    click_to_upload: 'Klik Untuk Muat Naik',
    vehicle_profile: 'Profil Kenderaan',
    vehicle_report: 'Laporan Kenderaan',
    chassis_no: 'Nombor Casis',
    fuel_rate: 'Kadar Bahan Api',
    toll_class: 'Kelas Tol',
    oil_volume: 'Isi Padu Minyak',
    tyre_management: 'Pengurusan Tayar',
    qr_code: 'Kod QR',
    print_vehicle_qrs: 'Cetak QR Kenderaan',
    certificate: 'Sijil',
    oil_measurement_setting: 'Tetapan Ukuran Minyak',
    total_fuel_usage: 'Jumlah Penggunaan Bahan Api',
    average_fuel_consumption: 'Purata Penggunaan Bahan Api',
    tyres_healthy_level: 'Tahap Kesihatan Tayar',
    vehicle_utilization: 'Penggunaan Kenderaan',
    vehicle_safety_level: 'Tahap Keselamatan Kenderaan',
    cost_per_km: 'Kos Per Km',
    cpk_value_rm: 'Nilai CPK (RM)',
    upcoming: 'Akan Datang',
    overdue: 'Tertunggak',
    group_average_fuel_performance: 'Purata Prestasi Bahan Api Kumpulan',
    ltr_fuel_waste_when_idling: '%{val} liter pembaziran bahan api semasa melahu',
    engine: 'Enjin',
    next_service_date: 'Tarikh Servis Seterusnya',
    remaining_km: 'Baki km',
    next_km: 'Km Seterusnya',
    last_km: 'Km Terkini',
    tyre_maintenance_log: 'Log Penyelenggaraan Tayar',
    updated_at: 'Dikemas Kini Pada',
    updated_by: 'Dikemas Kini Oleh',
    view_detail: 'Lihat Perincian',
    installed_date: 'Tarikh Pemasangan',
    tread_depth: 'Kedalaman Bunga',
    sn: 'N/S',
    tyre_pressure: 'Tekanan Tayar',
    brand: 'Jenama',
    used_km: 'Km Digunakan',
    model: 'Model',
    estimated_remaining_km: 'Jangkaan Km Baki',
    size: 'Saiz',
    cooling_system: 'Sistem Penyejukan',
    transmission_gear_box: 'Kotak Gear Transmisi',
    braking: 'Sistem Brek',
    body: 'Badan',
    other: 'Lain-lain',
    add_new_record: 'Tambah Rekod Baharu',
    vehicle_kpi: 'KPI Kenderaan',
    permit: 'Permit',
    roadtax: 'Cukai Jalan',
    sgp_roadtax: 'Cukai Jalan SGP',
    insurance: 'Insurans',
    expired_soon: 'Akan Tamat Tempoh',
    expired: 'Telah Tamat Tempoh',
    expired_date: 'Tarikh Tamat Tempoh',
    add_new_instance: 'Tambah Instance Baharu',
    new_instance: 'Instance Baharu',
    geofence_list: 'Senarai Geofence',
    integration_type: 'Jenis Integrasi',
    add_geofence: 'Tambah Geofence',
    add_new_geofence: 'Tambah Geofence Baharu',
    edit_geofence: 'Sunting Geofence',
    zone_type: 'Jenis Zon',
    mode: 'Mod',
    stop_type: 'Jenis Hentian',
    overtime_minute: 'Minit Lebih Masa',
    check_point: 'Titik Semak',
    check_point_without_notification: 'Titik Semak Tanpa Pemberitahuan',
    prohibited: 'Dilarang',
    in_region: 'Dalam Kawasan',
    out_region: 'Luar Kawasan',
    in_out_region: 'Dalam/Luar Kawasan',
    events: 'Peristiwa',
    driving_distance: 'Jarak Pemanduan',
    remaining: 'Baki',
    days: 'Hari',
    day: 'Hari',
    documentation_log: 'Log Dokumentasi',
    documentation: 'Dokumentasi',
    machinery_tracking: 'Penjejakan Mesin',
    safety_equipment: 'Peralatan Keselamatan',
    equipment: 'Peralatan',
    update_documentation_log: 'Kemas Kini Log Dokumentasi',
    update_machinery_tracking: 'Kemas Kini Penjejakan Mesin',
    update_equipment: 'Kemas Kini Peralatan',
    update_other: 'Kemas Kini Lain-lain',
    update_safety_equipment: 'Kemas Kini Peralatan Keselamatan',
    engine_on_date: 'Tarikh Enjin Dihidupkan',
    engine_on_remaining_duration_hours: 'Baki Tempoh Enjin Dihidupkan (Jam)',
    fire_extinguisher_expiry_date: 'Tarikh Luput Alat Pemadam Api',
    tanker_calibration_expiry_date: 'Tarikh Luput Kalibrasi Tangki',
    permit_no_expiry_date: 'No. Permit (Tarikh Luput)',
    roadtax_no_expiry_date: 'No. Cukai Jalan (Tarikh Luput)',
    singapore_roadtax_no_expiry_date: 'No. Cukai Jalan Singapura (Tarikh Luput)',
    puspakom_receipt_no_expiry_date: 'No. Resit Puspakom (Tarikh Luput)',
    insurance_sum_assured: 'Jumlah Dijamin Insurans',
    upload_by_time: 'Dimuat Naik oleh %{name} pada %{time}',
    fuel_price: 'Harga Bahan Api',
    default_price_rm: 'Harga Asas (RM)',
    default: 'Asas',
    default_rate: 'Kadar Asas',
    enter_rate: 'Masukkan Kadar',
    predefine: 'Pratentukan',
    please_enter_code: 'Sila Masukkan Kod',
    please_enter_description: 'Sila Masukkan Keterangan',
    please_enter_default_rate: 'Sila Masukkan Kadar Asas',
    please_enter_correct_rate: 'Sila Masukkan Kadar Betul',
    please_complete_all_rate_details: 'Sila Lengkapkan Semua Butiran Kadar',
    new_fuel_price: 'Harga Bahan Api Baru',
    create_fuel_price: 'Cipta Harga Bahan Api',
    update_fuel_price: 'Kemas Kini Harga Bahan Api',
    delete_fuel_price: 'Padam Harga Bahan Api',
    success: 'Berjaya',
    error: 'Ralat',
    new_maintenance_category: 'Kategori Penyelenggaraan Baru',
    create_maintenance_category: 'Cipta Kategori Penyelenggaraan',
    update_maintenance_category: 'Kemas Kini Kategori Penyelenggaraan',
    delete_maintenance_category: 'Padam Kategori Penyelenggaraan',
    speed_limit: 'Had Laju',
    max_idling_duration: 'Tempoh Melahu Maksimum',
    operation_hour_per_week: 'Jam Operasi Seminggu',
    goods_type: 'Jenis Barang',
    estimated_overload: 'Anggaran Beban Berlebihan',
    km: 'km',
    km_h: 'km/j',
    mins: 'minit',
    hrs: 'jam',
    perc: '%',
    kg: 'kg',
    lbs: 'lbs',
    l_100km: 'ℓ/100km',
    hour_s: 'Jam',
    l_idling_min: 'ℓ/minit melahu',
    l: 'ℓ',
    please_enter_speed_limit: "Sila Masukkan Had Laju",
    please_enter_max_idling_duration: "Sila Masukkan Tempoh Melahu Maksimum",
    please_enter_operation_hour_per_week: "Sila Masukkan Jam Operasi Seminggu",
    please_enter_estimated_overload: "Sila Masukkan Anggaran Beban Berlebihan",
    please_select_road_condition: "Sila Pilih Keadaan Jalan",
    please_enter_goods_type: "Sila Masukkan Jenis Barang",
    general_road: "Jalan Biasa",
    highway: "Lebuhraya",
    fleet_group_name: "Nama Kumpulan Armada",
    fleet_group: "Kumpulan Armada",
    fleet_group_details: "Butiran Kumpulan Armada",
    add_emergency_contact: "Tambah Kenalan Kecemasan",
    emergency_contact_person: "Orang Kenalan Kecemasan",
    emergency_contact_number: "Nombor Kenalan Kecemasan",
    emergency_response_plan_setting: "Tetapan Pelan Tindak Balas Kecemasan",
    erp_contact_person: "Orang Kenalan ERP",
    erp_contact_no: "Nombor Kenalan ERP",
    please_enter_fleet_group_name: "Sila Masukkan Nama Kumpulan Armada",
    please_enter_contact_person_name: "Sila Masukkan Nama Orang Kenalan",
    please_enter_contact_number: "Sila Masukkan Nombor Kenalan",
    please_enter_correct_contact_number: "Sila Masukkan Nombor Kenalan yang Betul",
    please_complete_emergency_contact_details: "Sila Lengkapkan Butiran Kenalan Kecemasan",
    please_enter_correct_erp_contact_number: "Sila Masukkan Nombor Kenalan ERP yang Betul",
    basic_information: "Maklumat Asas",
    privacy_information: "Maklumat Privasi",
    advance_information: "Maklumat Lanjutan",
    geotab_integration: "Integrasi Geotab",
    geotab_server: "Pelayan Geotab",
    geotab_database: "Pangkalan Data Geotab",
    geotab_username: "Nama Pengguna Geotab",
    geotab_password: "Kata Laluan Geotab",
    apad_gateway_integration: "Integrasi Gerbang APAD",
    api_key: "Kunci API",
    api_password: "Kata Laluan API",
    sovy_driver_preinspection_check_integration: "Integrasi Pemeriksaan Awal Pemandu Sovy",
    sovy_username: "Nama Pengguna Sovy",
    sovy_password: "Kata Laluan Sovy",
    api_link: "Pautan API",
    company_id: "ID Syarikat",
    branch_id: "ID Cawangan",
    idle_setting: "Tetapan Melahu",
    vehicle_listing: "Senarai Kenderaan",
    enter_vehicle: "Masukkan Kenderaan",
    selected_vehicle: "Kenderaan Terpilih",
    no_vehicle: "Tiada Kenderaan",
    new_vehicle: "Kenderaan Baru",
    everyday: "Setiap Hari",
    weekday: "Hari Bekerja",
    weekend: "Hujung Minggu",
    monday: "Isnin",
    tuesday: "Selasa",
    wednesday: "Rabu",
    thursday: "Khamis",
    friday: "Jumaat",
    saturday: "Sabtu",
    sunday: "Ahad",
    update_service_log: "Kemas Kini Log Servis",
    create_service_log: "Cipta Log Servis",
    delete_maintenance: "Padam Penyelenggaraan",
    create_fleet_group: "Cipta Kumpulan Armada",
    update_fleet_group: "Kemas Kini Kumpulan Armada",
    delete_fleet_group: "Padam Kumpulan Armada",
    tracker_details: "Butiran Penjejak",
    tracker: "Penjejak",
    new_tracker: "Penjejak Baru",
    please_select_tracker: "Sila Pilih Penjejak",
    class_1_toll: 'KELAS 1 (Kenderaan dengan 2 gandar dan 3 atau 4 roda tidak termasuk teksi)',
    class_2_toll: 'KELAS 2 (Kenderaan dengan 2 gandar dan 5 atau 6 roda tidak termasuk bas)',
    class_3_toll: 'KELAS 3 (Kenderaan dengan 3 atau lebih gandar)',
    class_4_toll: 'KELAS 4 (Teksi)',
    class_5_toll: 'KELAS 5 (Bas)',
    class_1_penang_toll: 'KELAS 1 (Motosikal)',
    class_2_penang_toll: 'KELAS 2 (Kenderaan komersial dengan 3 roda dan kereta termasuk station wagon)',
    class_3_penang_toll: 'KELAS 3 (Lori dan van dengan 2 gandar dan 4 roda serta Bas dengan 2 gandar dan 4 roda)',
    class_4_penang_toll: 'KELAS 4 (Lori dan van dengan 2 gandar dan 5 atau 6 roda serta Bas dengan 2 gandar dan 5 atau 6 roda)',
    class_5_penang_toll: 'KELAS 5 (Kenderaan/Bas dengan 3 gandar)',
    class_6_penang_toll: 'KELAS 6 (Kenderaan dengan 4 gandar)',
    class_7_penang_toll: 'KELAS 7 (Kenderaan dengan 5 gandar atau lebih)',
    tyre_setting: 'Tetapan Tayar',
    tyre_maintenance: 'Penyelenggaraan Tayar',
    esg_setting: 'Tetapan ESG',
    esg_module: 'Modul ESG',
    fuel_benchmark_setting: 'Tetapan Penanda Aras Bahan Api',
    fuel_efficiency: "Kecekapan Bahan Api",
    fuel_wastage_rate: "Kadar Pembaziran Bahan Api",
    toll_setting: "Tetapan Tol",
    penang_bridge_class: "Kelas Jambatan Pulau Pinang",
    mpob_integration: "Integrasi MPOB",
    mpob_device_id: "ID Peranti MPOB",
    cargomove_integration: 'Integrasi CargoMove',
    cargomove_plate_no: 'No Plat CargoMove',
    lpj_integration: 'Integrasi LPJ',
    lpj_plate_no: 'No Plat LPJ',
    migration_settings: 'Tetapan Migrasi',
    migration_server: 'Pelayan Migrasi',
    migration_cutoff_date: 'Tarikh Akhir Migrasi',
    migration_plate_no: 'No Plat Migrasi',
    please_select_migration_server: 'Sila pilih pelayan migrasi',
    please_select_migration_cutoff_date: 'Sila pilih tarikh akhir migrasi',
    upload: 'Muat Naik',
    reupload: 'Muat Naik Semula',
    download: 'Unduh',
    are_you_sure_you_want_to_upload: 'Adakah anda pasti ingin memuat naik: ',
    tank_info: 'Maklumat Tangki',
    driver_reference: 'Rujukan Pemandu',
    driver_2: 'Pemandu 2',
    region: 'Kawasan',
    transport_type: 'Jenis Pengangkutan',
    display_details: 'Paparkan Butiran',
    vehicle_icon: 'Ikon Kenderaan',
    marker_image: 'Imej Penanda',
    oil_setting: 'Tetapan Minyak',
    fuel_price_selection: 'Pemilihan Harga Bahan Api',
    engine_hour_setting: 'Tetapan Jam Enjin',
    engine_hour_meter: 'Meter Jam Enjin',
    system_calculated_engine_hour: 'Jam Enjin Dikira Sistem',
    adjust_to_engine_hour: 'Sesuaikan Ke Jam Enjin',
    last_engine_hour_adjustment: 'Pelarasan Jam Enjin Terakhir',
    please_note_that_any_adjustment_will_calculated_when_its_synced_engine_hour_is_available: "* Sila ambil perhatian bahawa sebarang pelarasan akan dikira apabila jam enjin disegerakkan tersedia",
    'set_adjust_to_engine_hour_to_-1_for_remove_the_adjustment': '* Tetapkan sesuaikan ke jam enjin kepada -1 untuk membuang pelarasan',
    pto_critical_alert: 'Amaran Kritikal PTO',
    pto_2_critical_alert: 'Amaran Kritikal PTO 2',
    pto_display: 'Paparan PTO',
    pto_display_2: 'Paparan PTO 2',
    pto_door_sensor: 'Sensor Pintu PTO',
    alert_triggered: 'Amaran Dijalankan',
    when_pto_is_on: 'Apabila PTO Diaktifkan',
    when_pto_is_off: 'Apabila PTO Dimatikan',
    never_trigger: 'Jangan Pernah Jalankan',
    upload_profile_image: 'Muat Naik Imej Profil',
    confirm_upload: 'Sahkan Muat Naik',
    remove_selected_image: 'Buang Imej Dipilih',
    billing_entity_name: 'Nama Entiti Pengebilan',
    billing_entity: 'Entiti Pengebilan',
    vehicle_document: 'Dokumen Kenderaan',
    voltage: 'Voltan',
    power_status: 'Status Daya',
    power_status_off: 'Mati',
    power_status_normal: 'Normal',
    power_status_abnormal: 'Tidak Normal',
    power_status_error: 'Error',
    power_status_weak: 'Lemah',
    power_status_healthy: 'Sehat',
    power_status_aware: 'Berjaga-jaga',
    create_vehicle: 'Cipta Kenderaan',
    update_vehicle: 'Kemas Kini Kenderaan',
    vehicle_updated_successfully: 'Berjaya dikemaskini',
    delete_vehicle: 'Padam Kenderaan',
    delete_tracker: 'Padam Penjejak',
    IDLING: 'Melahu',
    DRIVING: 'Memandu',
    PARKING: 'Parkir',
    OFFLINE: 'Luar Talian',
    battery: 'Bateri',
    satellite: 'Satelit',
    antenna: 'Antena',
    odometer: 'Odometer',
    fuel_details: 'Butiran Bahan Api',
    device_model: 'Model Peranti',
    terminal_id: 'ID Terminal',
    timezone: 'Zon Waktu',
    fuel_enable: 'Bahan Api Diaktifkan',
    device_mode: 'Mod Peranti',
    rotation_sensor_setting: 'Tetapan Sensor Putaran',
    rotation_sensor: 'Sensor Putaran',
    temperature_sensor_setting: 'Tetapan Sensor Suhu',
    temperature_sensor: 'Sensor Suhu',
    fuel_sensor_setting: 'Tetapan Sensor Bahan Api',
    fuel_sensor: 'Sensor Bahan Api',
    minimum_refuel_detection: 'Pengesanan Isi Semula Minimum',
    minimum_tank_lvl_oil_resistance: 'Tahap Tangki Minimum (%) / Rintangan Minyak (ohm)',
    maximum_tank_lvl_oil_resistance: 'Tahap Tangki Maksimum (%) / Rintangan Minyak (ohm)',
    fuel_tap_sensor: 'Sensor Injap Minyak',
    reverse_ohm: 'Terbalik (ohm)',
    sensor_type: 'Jenis Sensor',
    tank_volume: 'Isipadu Tangki',
    general: 'Umum',
    reverse: 'Terbalik',
    create_tracker: 'Cipta Penjejak',
    update_tracker: 'Kemaskini Penjejak',
    please_enter_sim_card_no: 'Sila masukkan nombor kad SIM',
    please_select_device_mode: 'Sila pilih mod peranti',
    please_enter_device_id: 'Sila masukkan ID peranti',
    please_select_device_type: 'Sila pilih jenis peranti',
    please_select_protocol_type: 'Sila pilih jenis protocol',
    medical_expiry_date: 'Tarikh Luput Perubatan',
    create_driver: 'Cipta Pemandu',
    update_driver: 'Kemaskini Pemandu',
    resigned: 'Berhenti',
    suspended: 'Digantung',
    employed: 'Diambil Bekerja',
    please_enter_driver_name: 'Sila masukkan nama pemandu',
    please_select_employment_status: 'Sila pilih status pekerjaan',
    delete_driver: 'Padam Pemandu',
    vehicle_status: 'Status Kenderaan',
    update_vehicle_status: 'Kemaskini Status Kenderaan',
    generating_certificate: 'Menjana Sijil',
    please_wait_while_we_download_your_file_this_may_take_awhile_thanks: 'Sila tunggu semasa kami memuat turun fail anda, ini mungkin mengambil masa sebentar, terima kasih',
    map_instance: 'Instans Peta',
    map_not_ready_yet: 'Peta belum siap lagi',
    owner: 'Pemilik',
    only_shown_account_enable: 'Hanya Akaun Ditunjukkan Diaktifkan',
    user: 'Pengguna',
    integration_list: 'Senarai Integrasi',
    online_status: 'Status Dalam Talian',
    offline_duration: 'Tempoh Luar Talian',
    peripheral_offline_duration: 'Tempoh Luar Talian Periferal',
    movement_status: 'Status Pergerakan',
    please_enter_map_instance_name: 'Sila masukkan nama instans peta',
    please_select_integration_type: 'Sila pilih jenis integrasi',
    please_select_owner: 'Sila pilih pemilik',
    please_select_only_shown_account_enable: 'Sila pilih Hanya Akaun Ditunjukkan Diaktifkan',
    please_select_integration_list: 'Sila pilih senarai integrasi',
    profile: 'Profil',
    device_settings: 'Tetapan Peranti',
    user_settings: 'Tetapan Pengguna',
    manage_temporary_view: 'Urus Paparan Sementara',
    company_rules_complaints: 'Peraturan Syarikat & Aduan',
    help_center: 'Pusat Bantuan',
    contact_us: 'Hubungi Kami',
    contact_us_banner_title: 'Kami sedia membantu anda.',
    contact_us_banner_subtitle: 'Kami ingin mendengar daripada anda',
    need_our_help: 'Perlukan bantuan kami?',
    email_address: 'Alamat E-mel',
    your_issue: 'Isu Anda',
    please_enter_your_issue: 'Sila Masukkan Isu Anda',
    please_complete_recaptcha: 'Sila lengkapkan pengesahan reCAPTCHA',
    contact_us_submitted_successfully: 'Terima kasih kerana menghubungi kami. Kami amat menghargai maklum balas anda dan akan membalas anda secepat mungkin.',
    edit_password: 'Edit Kata Laluan',
    update_password_successfully: 'Kata Laluan Berjaya Dikemaskini',
    company_logo: 'Logo Syarikat',
    current_password: 'Kata Laluan Semasa',
    new_password: 'Kata Laluan Baru',
    confirm_password: 'Sahkan Kata Laluan',
    please_enter_current_password: 'Sila masukkan kata laluan semasa',
    please_enter_new_password: 'Sila masukkan kata laluan baru',
    please_enter_confirm_password: 'Sila masukkan sahkan kata laluan',
    password_not_match: 'Kata Laluan Tidak Sepadan',
    faqs: 'Soalan Lazim',
    frequently_asked_questions: 'Soalan Lazim',
    keyword: 'Kata Kunci',
    focus_on: 'Tumpu Pada',
    driving_duration: 'Tempoh Pemanduan',
    create_map_instance: 'Cipta Instans Peta',
    update_map_instance: 'Kemaskini Instans Peta',
    delete_map_instance: 'Padam Instans Peta',
    focus_vehicle: 'Tumpu Kenderaan',
    driving: 'Memandu',
    fill_color: 'Isi Warna',
    stroke_color: 'Warna Garisan',
    delete_geofence: 'Padam Geofence',
    create_geofence: 'Cipta Geofence',
    update_geofence: 'Kemaskini Geofence',
    new_map_instance: 'Instans Peta Baru',
    create_poi: 'Tambah POI',
    update_poi: 'Kemaskini POI',
    delete_poi: 'Padam POI',
    create_checkpoint: 'Tambah pusat pemeriksaan',
    update_checkpoint: 'Kemas kini pusat pemeriksaan',
    delete_checkpoint: 'Padamkan stesen',
    meter: 'Meter',
    please_enter_poi_name: 'Sila masukkan nama POI',
    please_enter_poi_latitude: 'Sila masukkan latitud POI',
    please_enter_poi_longitude: 'Sila masukkan longitud POI',
    please_select_poi_icon: 'Sila pilih ikon POI',
    please_enter_poi_radius: 'Sila masukkan radius POI',
    please_enter_checkpoint_name: 'Sila masukkan nama pusat pemeriksaan',
    please_enter_checkpoint_latitude: 'Sila masukkan latitud pusat pemeriksaan',
    please_enter_checkpoint_longitude: 'Sila masukkan longitud pusat pemeriksaan',
    please_enter_checkpoint_radius: 'Sila masukkan radius pusat pemeriksaan',
    please_choose_checkpoint_type: 'Sila pilih jenis pusat pemeriksaan',
    firmware_management: 'Pengurusan Firmware',
    geofence_settings: 'Tetapan Geofence',
    alarm_configuration_vehicle_control: 'Konfigurasi Penggera / Kawalan Kenderaan',
    please_select_vehicle_to_set_alert_configurations_controls: 'Sila pilih kenderaan untuk menetapkan konfigurasi amaran / kawalan',
    enter_keyword_to_search: 'Masukkan kata kunci untuk mencari',
    device_settings_mode: 'Mod Tetapan Peranti',
    upload_firmware: 'Muat Naik Firmware',
    file_name: 'Nama Fail',
    firmware_upload: 'Muat Naik Firmware',
    click_here_to_upload_or_drop_your_files_here: 'Klik di sini untuk memuat naik atau seret fail anda ke sini',
    file: 'Fail',
    please_upload_firmware_file: 'Sila muat naik fail firmware',
    create_device_firmware: 'Cipta Firmware Peranti',
    update_device_firmware: 'Kemaskini Firmware Peranti',
    proceed: 'Teruskan',
    fleet_list: 'Senarai Armada',
    selected_fleet: 'Armada Dipilih',
    deselect: 'Nyahpilih',
    select: 'Pilih',
    vehicle_list: 'Senarai Kenderaan',
    hint: 'Petunjuk',
    device_firmware: 'Firmware Peranti',
    send: 'Hantar',
    please_select_device_firmware: 'Sila pilih firmware peranti',
    is_required: 'Diperlukan',
    wrong_format: 'Format Salah',
    must_be_a_number: 'Mesti nombor',
    immobilizer_password: 'Kata Laluan Immobilizer',
    please_enter_immobilizer_password: 'Sila masukkan kata laluan immobilizer',
    alarm_configuration_vehicle_control_history: 'Sejarah Konfigurasi Penggera / Kawalan Kenderaan',
    alarm_configuration_vehicle_control_records: 'Rekod Konfigurasi Penggera / Kawalan Kenderaan',
    cancelled: 'Dibatalkan',
    sent: 'Dihantar',
    settings_information: 'Maklumat Tetapan',
    settings: 'Tetapan',
    value: 'Nilai',
    return_raw: 'Pulangkan Data Mentah',
    return_value: 'Pulangkan Nilai',
    resend: 'Hantar Semula',
    refresh: 'Segarkan',
    cancel_all_command: 'Batalkan Semua Arahan',
    resend_all_command: 'Hantar Semula Semua Arahan',
    account_type: 'Jenis Akaun',
    new_user: 'Pengguna Baru',
    user_details: 'Butiran Pengguna',
    system_setting: 'Tetapan Sistem',
    email_reporting_extra_modules: 'Laporan E-mel / Modul Tambahan',
    fleet_group_listing: 'Senarai Kumpulan Armada',
    weeklyOverspeedMailEnable: 'E-mel Kelajuan Berlebihan Mingguan Dihidupkan',
    weeklySummaryMailEnable: 'E-mel Ringkasan Mingguan Dihidupkan',
    dailySummaryMailEnable: 'E-mel Ringkasan Harian Dihidupkan',
    dailyMaintenanceMailEnable: 'E-mel Penyelenggaraan Harian Dihidupkan',
    monthlyVehicleMileageMailEnable: 'E-mel Perbatuan Kenderaan Bulanan Dihidupkan',
    admin: 'Pentadbir',
    main_account: 'Akaun Utama',
    sub_account: 'Sub Akaun',
    notification_email: 'E-mel Pemberitahuan',
    notification_telephone_no: 'No. Telefon Pemberitahuan',
    add_notification_email: 'Tambah E-mel Pemberitahuan',
    add_notification_telephone_no: 'Tambah No. Telefon Pemberitahuan',
    recipients: 'Penerima',
    alert_types: 'Jenis Makluman',
    critical_notifications: 'Pemberitahuan kritikal',
    ai_notifications: 'Pemberitahuan AI',
    tracking_page_data_interval_in_second: 'Selang Data Laman Penjejakan (Dalam Saat)',
    idling_video_streaming_limit_minutes: 'Tempoh Penstriman Video Melahu',
    idling_video_streaming_limit_minutes_default: '5 Minit (Lalai)',
    suggested_value: 'Nilai Dicadangkan',
    currency_display: 'Paparan Mata Wang',
    initial_map_location: 'Lokasi Peta Awal',
    critical_alert_filter: 'Penapis Amaran Kritikal',
    select_fleet_group: 'Pilih Kumpulan Armada',
    no_fleet_group: 'Tiada Kumpulan Armada',
    selected_fleet_group: 'Kumpulan Armada Dipilih',
    new_fleet_group: 'Kumpulan Armada Baru',
    new_company: 'Syarikat Baru',
    company_name: 'Nama Syarikat',
    company_registration_no: 'No Pendaftaran Syarikat',
    company_contact_person: 'Orang Hubungan Syarikat',
    company_contact_no: 'No Hubungan Syarikat',
    company_details: 'Butiran Syarikat',
    company_address: 'Alamat Syarikat',
    user_listing: 'Senarai Pengguna',
    select_user: 'Pilih Pengguna',
    selected_user: 'Pengguna Dipilih',
    no_user: 'Tiada Pengguna',
    detail: 'Butiran',
    role: 'Peranan',
    new_role: 'Peranan Baru',
    roles_details: 'Butiran Peranan',
    role_name: 'Nama Peranan',
    features_enabled: 'Ciri-ciri Dihidupkan',
    modules: 'Modul',
    features: 'Ciri-ciri',
    get: 'Dapatkan',
    update: 'Kemaskini',
    create: 'Cipta',
    refuse_all: 'Tolak Semua',
    grant_all: 'Beri Semua',
    select_module_first: 'Pilih Modul Dahulu',
    new_setting: 'Tetapan Baru',
    setting_name: 'Nama Tetapan',
    using_users_fleet: 'Menggunakan Armada Pengguna',
    email_notification_setting_details: 'Butiran Tetapan Pemberitahuan E-mel',
    notification_setting_details: 'Butiran Tetapan Pemberitahuan',
    create_new_notification_setting: 'Buat Tetapan Pemberitahuan Baharu',
    notify_email_entry: 'Pemberitahuan Kemasukan E-mel',
    notify_entry: 'Pemberitahuan Kemasukan',
    switch_notification_method: 'Tukar Kaedah Pemberitahuan',
    geofence_instance_filter: 'Penapis Instans Geofence',
    notification_enabled: 'Pemberitahuan Dihidupkan',
    nearby: 'Berdekatan',
    checklist_profile: 'Profil Senarai Semak',
    total_fuel_spend: 'Total Perbelanjaan Bahan Api',
    total_distance: 'Jarak Total',
    score: 'Skor',
    copy_vehicle_info: 'Salin informasi kenderaan ke papan klip berjaya',
    shortcuts: 'Pintasan',
    starred_your_favourites_to_quick_access: 'Menandai favorit anda untuk akses cepat',
    roadtax_attachment: 'Lampiran-lampiran Roadtax',
    permit_attachment: 'Lampiran-lampiran Permit',
    notifications: 'Notifikasi',
    view_all_notifications: 'Lihat Semua Notifikasi',
    critical_alert: 'Amaran Kritikal',
    notification: 'Notifikasi',
    driving_behaviour: 'Perilaku Kereta',
    grid_of: "Grid bagi %{column}",
    columns: 'Kolom',
    spotlight: 'Lampu Sorot',
    no_data_available: 'Tiada Data Tersedia',
    no_notification: 'Tiada Notifikasi',
    please_select_fleet_group_or_vehicle_first: 'Sila pilih kumpulan armada atau kenderaan pertama',
    enter_plate_no: 'Masukkan No Plat',
    select_type: 'Pilih Jenis',
    please_complete_all_required_fields: 'Sila Lengkapkan Semua Medan Diperlukan',
    please_enter_email: 'Sila Masukkan E-mel',
    please_select_account_type: 'Sila Pilih Jenis Akaun',
    please_select_status: 'Sila Pilih Status',
    template_name: 'Nama Templat',
    company_checklist: 'Senarai Semak Syarikat',
    checklist: 'Senarai Semak',
    please_select_checklist: 'Sila Pilih Senarai Semak',
    please_enter_company_name: 'Sila Masukkan Nama Syarikat',
    new_checklist: 'Senarai Semak Baru',
    select_a_workshop: 'Select a Workshop',
    rating_date: 'Rating Date',
    workshop_name: 'Workshop Name',
    checklist_details: 'Butiran Senarai Semak',
    select_a_company: 'Pilih Syarikat',
    checklist_name: 'Nama Senarai Semak',
    checklist_item_name: 'Nama Senarai Semak',
    enable_remark: 'Benarkan Nota',
    enable_attachment: 'Benarkan Lampiran',
    add_new_checklist_item: 'Tambah Senarai Semak Baru',
    checklist_items: 'Senarai Semak',
    select_a_status: 'Pilih Status',
    please_enter_city: 'Sila Masukkan Bandar',
    please_enter_contact_no: 'Sila Masukkan Nombor Hubungi',
    new_breakdown_support: 'Sokongan Perkembangan Baru',
    city: 'Bandar',
    contact_person: 'Orang Hubungi',
    latitude: 'Latitud',
    longitude: 'Longitude',
    pos_code: 'Pos Code',
    speciality: 'Jenis Istimewa',
    breakdown: 'Perkembangan',
    smart_fleet_analytics_dashboard: 'Papan Pemuka Analitik Armada Pintar',
    revenue_analysis_report: 'Laporan Analisis Hasil',
    total_expenses: 'Jumlah Perbelanjaan',
    total_earning: 'Jumlah Pendapatan',
    current_total_earning: 'Jumlah Pendapatan Semasa',
    cost_trend_report: 'Laporan Trend Kos',
    total_trip_cost: 'Jumlah Kos Perjalanan',
    total_maintenance_cost: 'Jumlah Kos Penyelenggaraan',
    average_monthly_cost: 'Kos Bulanan Purata',
    trip_cost: 'Kos Perjalanan',
    maintenance_cost: 'Kos Penyelenggaraan',
    trip_cost_breakdown: 'Laporan Kos Perjalanan',
    fuel_purchased: 'Minyak Dibeli',
    toll_cost: 'Kos Tol',
    driver_expense: 'Perbelanjaan Pemandu',
    add_report_to_starred_success: 'Tambahkan Laporan ke Starred berhasil',
    remove_report_from_starred_success: 'Laporan berjaya dikeluarkan daripada senarai kegemaran',
    remove_shortcut_success: 'Kembalikan pintasan berjaya',
    add_shortcut_success: 'Tambahkan pintasan berjaya',
    maintenance_cost_breakdown: 'Laporan Kos Penyelenggaraan',
    expense: 'Kelayakan',
    earning: 'Penghargaan',
    top5_high_maintenance_cost: 'Top 5 Kos Penyelenggaraan Tinggi',
    fuel_performance_trend_report_for_industry_profile: 'Laporan Trend Performa untuk Profil Perusahaan',
    operation_performance: 'Performa Operasi',
    total_fuel_cost: 'Total Kos Minyak',
    est_idling_cost: 'Est Idling Cost',
    industry_profile_efficiency_target: 'Kelayakan Keselarasan Profil Perusahaan',
    industry_profile_efficiency_baseline: 'Kelayakan Keselarasan Profil Perusahaan',
    fuel_consumption_auto_refuel: 'Minyak (Auto Refuel)',
    fuel_purchase_refuel: 'Pembelian Minyak (Refuel)',
    utilization_rate: 'Laporan Penggunaan',
    fuel_performance: 'Performa Minyak',
    revenue_rm: 'Penghargaan (RM)',
    operational_performance_rm_km: 'Performa Operasi (RM/km)',
    average_per_vehicle: 'Rata-rata Per Kenderaan',
    this_month: 'Bulan Ini',
    target: 'Sasaran',
    total_cost_breakdown: 'Pecahan Jumlah Kos',
    top5_maintenance_breakdown: 'Pecahan 5 Penyelenggaraan Teratas',
    fuel_liter: 'Bahan Api (Liter)',
    total_vehicles: 'Jumlah Kenderaan',
    today_active: 'Aktif Hari Ini',
    today_inactive: 'Tidak Aktif Hari Ini',
    average_driver_score_speed: 'Skor Pemandu & Kelajuan',
    speed_km_h: 'Kelajuan (km/h)',
    average_idling_rate_per_total_driving_time: 'Rata-rata Penggunaan Melahu Per Masa Penyelenggaraan Jumlah',
    average_speeding_rate_per_total_driving_time: 'Rata-rata Penggunaan Penyelah Per Masa Penyelenggaraan Jumlah',
    average_harsh_event_per_total_driving_time: 'Rata-rata Perilaku Berbahaya Per Masa Penyelenggaraan Jumlah',
    top5_high_idling_event: 'Peristiwa Melahu Teratas',
    top5_high_speeding_event: 'Peristiwa Penyelah Teratas',
    top5_high_harsh_event: 'Peristiwa Berbahaya Teratas',
    fleet_idling_rate_trend: 'Trend Penggunaan Melahu Armada',
    fleet_speeding_rate_trend: 'Trend Penggunaan Penyelah Armada',
    fleet_harsh_event_trend: 'Trend Perilaku Berbahaya Armada',
    idling_of_total_drive_time_percentage: 'Penggunaan Melahu Jumlah Masa Penyelenggaraan (%)',
    speeding_of_total_drive_time_percentage: 'Penggunaan Penyelah Jumlah Masa Penyelenggaraan (%)',
    harsh_event_per_1000_km: 'Perilaku Berbahaya Per 1000 km',
    score_distribution: 'Distribusi Skor',
    poor: 'Sedikit',
    meet_goals: 'Mencapai Tujuan',
    top_performance: 'Performa Tertinggi',
    risk_factors_speeding: 'Risiko - Penyelah',
    tag: 'TAG',
    count: 'JUMLAH',
    rate_or_percentage: 'RATE atau %',
    score_impact: 'IMPAKAN SKOR',
    driver_count: 'Jumlah Pemandu',
    vehicle_history: 'Sejarah Kenderaan',
    fuel_setting_history: 'Sejarah Tetapan Bahan Api',
    new_record: 'Rekam Baru',
    vehicle_record: 'Rekam Kenderaan',
    efficient_date: 'Tanggal Efisien',
    delete_vehicle_record: 'Padam Rekam Kenderaan',
    delete_fuel_setting_record: 'Padam Rekam Tetapan Bahan Api',
    fuel_setting_record: 'Rekam Tetapan Bahan Api',
    vehicle_setting: 'Tetapan Kenderaan',
    request_ip: 'IP Permintaan',
    request_url: 'URL Permintaan',
    enter_keyword: 'Masukkan Kata Kunci',
    please_enter_keyword: 'Sila Masukkan Kata Kunci',
    please_select_mode: 'Sila Pilih Mod',
    please_select_object_type: 'Sila Pilih Jenis Objek',
    please_select_user: 'Sila Pilih Pengguna',
    insert: 'Memasukkan',
    tollName: 'Nama Tol',
    groupName: 'Nama Kumpulan',
    tollGroupName: 'Nama Kumpulan Tol',
    rateType: 'Jenis Kadar Tol',
    new_toll: 'Tol Baru',
    toll_point_panels: 'Panel Lokasi Tol',
    create_a_toll_line: 'Buat Laluan Tol',
    There_is_no_toll_line: 'Tiada sebarang laluan tol lagi',
    enter_name: 'Masukkan Nama',
    select_point_type: 'Sila Pilih Jenis Hentian',
    entry: 'Masuk',
    exit: 'Keluar',
    toll_list: 'Senarai Tol',
    selected_toll_list: 'Senarai Tol Pilihan',
    edit_toll_list: 'Edit Senarai Tol',
    add_list: 'Tambah',
    remove_list: 'Padam',
    enter_group_name: 'Isi Nama Kumpulan',
    group_name_is_required: 'Nama Kumpulan Diperlukan',
    tolls: 'Tol',
    single: 'Tunggal',
    multi: 'Pelbagai',
    price_monthly: 'Harga (Bulanan)',
    go_to_market_place: 'Pergi ke Laman Pasaran',
    insurance_details: 'Butiran Insurans',
    price: 'Harga',
    claim: 'Tuntutan',
    claim_history: 'Sejarah Tuntutan',
    renew: 'Memperbaharui',
    select_a_driver: 'Pilih Pemandu',
    severity: 'Keterukan',
    avg_exceed: 'Purata Melebihi',
    avg_speed_limit: 'Purata Kelajuan/Had Kelajuan',
    time_and_location: 'Masa & Lokasi',
    select_a_route: 'Pilih Laluan',
    new_route: 'Laluan Baru',
    new_route_group: 'Kumpulan Laluan Baru',
    route: 'Laluan',
    route_type: 'Jenis Laluan',
    route_details: 'Butiran Laluan',
    select_group_name: 'Pilih Nama Kumpulan',
    select_a_route_type: 'Pilih Jenis Laluan',
    select_a_route_group: 'Pilih Kumpulan Laluan',
    select_a_code: 'Pilih Kod',
    type_route_name_here: 'Sila masukkan nama laluan disini',
    type_route_code_here: 'Sila masukkan kod laluan disini',
    submit: 'Hantar',
    map_details: 'Butiran Peta',
    assign_by_operator: 'Ditugaskan Oleh Operator',
    route_group_details: 'Butiran Kumpulan Laluan',
    shift_details: 'Butiran Syif',
    add_shift: 'Tambah Syif',
    shift_code: 'Kod Syif',
    shift: 'Syif',
    assign: 'Tugaskan',
    current_route_group: 'Kumpulan Laluan Semasa',
    job_type: 'Jenis Kerja',
    phone: 'Telefon',
    pic: 'PIC',
    sequence: 'Urutan',
    edit_route: 'Edit Laluan',
    lite_access: 'Akses Lite',
    operation_hour_date: 'Tarikh Jam Enjin',
    operation_hour_affordable_hour: 'Jam Enjin Dihidupkan',
    operation_hour_remaining_hour: 'Jam Enjin Tersisa',
    operation_hour_remaining_hour_status: 'Status Jam Enjin Tersisa',
    fire_extinguisher_reminder_day: 'Hari Pengumpul Penyilam',
    total_mileage_of_month: 'Jumlah Jarak Bulanan',
    total_mileage_per_day: 'Jumlah Jarak Perjalanan Sehari',
    engine_date: 'Tarikh Enjin',
    engine_expiry_date: 'Tarikh Kedaluwarsa Enjin',
    engine_affordable_mileage: 'Perbatasan Enjin',
    engine_current_mileage: 'Perbatasan Enjin Semasa',
    engine_remaining_mileage: 'Perbatasan Enjin Tersisa',
    engine_remaining_mileage_status: 'Status Perbatasan Enjin Tersisa',
    operation_hour_renew: 'Pembaharuan Jam Operasi',
    last_operation_start_date: 'Tarikh Mula Operasi Terakhir',
    other_maintenance_affordable_engine_hours: 'Jam Enjin Mampu untuk Penyelenggaraan Lain',
    fire_extinguisher_renew: 'Pembaharuan Alat Pemadam Api',
    reminder_day: 'Hari Peringatan',
    engine_renew: 'Pembaharuan Enjin',
    next_engine_maintenance_due_date: 'Tarikh Penyelenggaraan Enjin Seterusnya',
    current_mileage_maintenance_mileage_km: 'Jarak Perbatuan Semasa untuk Penyelenggaraan (km)',
    engine_maintenance_affordable_mileage_km: 'Jarak Perbatuan Mampu untuk Penyelenggaraan Enjin (km)',
    delete_role: 'Padam Peranan',
    system_predefined: 'Pratetap Sistem',
    enable: 'Benarkan',
    other_1_title: 'Jenis Dokumen Lain 1',
    other_1_type: 'Jenis Lain 1',
    other_2_title: 'Jenis Dokumen Lain 2',
    other_2_type: 'Jenis Lain 2',
    other_3_title: 'Jenis Dokumen Lain 3',
    other_3_type: 'Jenis Lain 3',
    other_4_title: 'Jenis Dokumen Lain 4',
    other_4_type: 'Jenis Lain 4',
    affordable_hour: 'Jam Mampu',
    create_role: 'Buat Peranan',
    update_role: 'Perbaharui Peranan',
    new_package: 'Paket Baru',
    delete_package: 'Padam Paket',
    create_package: 'Buat Paket',
    update_package: 'Perbaharui Paket',
    package: 'Paket',
    package_name: 'Nama Paket',
    package_details: 'Butiran Paket',
    default_enable: 'Aktif Lalai',
    expiry: 'Kedaluwarsa',
    permit_reminder_day: 'Hari Peringatan Permit',
    roadtax_reminder_day: 'Hari Peringatan Cukai Jalan',
    sgp_roadtax_reminder_day: 'Hari Peringatan SGP Cukai Jalan',
    puspakom_reminder_day: 'Hari Peringatan Puspakom',
    service_reminder_day: 'Hari Peringatan Servis',
    sgp_roadtax_attachment: 'Lampiran SGP Cukai Jalan',
    puspakom_attachment: 'Lampiran Puspakom',
    service_attachment: 'Lampiran Servis',
    service_affordable_mileage: 'Jarak Perbatuan Mampu untuk Servis',
    service_current_mileage: 'Jarak Perbatuan Semasa untuk Servis',
    service_remaining_mileage: 'Baki Jarak Perbatuan untuk Servis',
    sgp_roadtax_no: 'No SGP Cukai Jalan',
    insurance_reserved_cost: 'Biaya Penghematan',
    insurance_reminder_day: 'Hari Peringatan Penghematan',
    insurance_attachment: 'Lampiran Penghematan',
    update_documentation: 'Kemas Kini Dokumentasi',
    delete_attachment: 'Padam Lampiran',
    file_size_exceeds_limit: 'Saiz Fail melebihi had (5mb)',
    please_select_billing_entity: 'Sila pilih perniaga pelayaran',
    please_enter_plate_no: 'Sila masukkan nombor plat',
    energy_source: 'Sumber Enjin',
    petrol: 'Petrol',
    diesel: 'Diesel',
    electric: 'Elektrik',
    new_trailer: 'Trailer Baru',
    pma_reminder_day: 'Hari Peringatan PMA',
    pma_attachment: 'Lampiran PMA',
    delete_trailer: 'Padam Trailer',
    trailer_icon: 'Ikon Trailer',
    prime_mover_vehicle_id: 'ID Kenderaan Prime Mover',
    gps_tracker_integration: 'Integrasi Tracker GPS',
    create_trailer: 'Buat Trailer',
    update_trailer: 'Perbaharui Trailer',
    notification_settings: 'Pengaturan Notifikasi',
    permission_settings: 'Pengaturan Izin',
    fleet_group_settings: 'Pengaturan Grup Fleet',
    first_name: 'Nama Depan',
    last_name: 'Nama Belakang',
    super_administrator: 'Pentadbir Super',
    support: 'Sokongan',
    partnership: 'Perkongsian',
    personal_fleet: 'Flit Peribadi',
    fleet_company: 'Syarikat Flit',
    merchant: 'Peniaga',
    email_settings: 'Pengaturan Email',
    fleet_settings: 'Tetapan Fleet',
    control_password: 'Kata Sandi Kontrol',
    nickname: 'Nama Panggilan',
    main_user: 'Pengguna Utama',
    create_user: 'Buat Pengguna',
    update_user: 'Perbarui Pengguna',
    delete_user: 'Padam Pengguna',
    trackvision_role: 'Peranan Trackvision',
    billing_entity_settings: 'Tetapan Entiti Pelayaran',
    package_settings: 'Tetapan Paket',
    main_sub_account: 'Akaun Induk/Sub',
    view_permit_history: 'Lihat Sejarah Permit',
    view_roadtax_history: 'Lihat Sejarah Cukai Jalan',
    view_sgp_roadtax_history: 'Lihat Sejarah Cukai Jalan SGP',
    view_puspakom_history: 'Lihat Sejarah Puspakom',
    view_service_history: 'Lihat Sejarah Servis',
    permit_history: 'Sejarah Permit',
    roadtax_history: 'Sejarah Cukai Jalan',
    sgp_roadtax_history: 'Sejarah Cukai Jalan SGP',
    puspakom_history: 'Sejarah Puspakom',
    service_history: 'Sejarah Servis',
    document_no: 'No Dokumen',
    delete_history: 'Padam Sejarah',
    other_history: 'Sejarah Lain',
    view_other_history: 'Lihat Sejarah Lain',
    view_operation_hour_history: 'Lihat Sejarah Jam Enjin',
    operation_hour_history: 'Sejarah Jam Enjin',
    view_fire_extinguisher_history: 'Lihat Sejarah Alat Pemadam Api',
    fire_extinguisher_history: 'Sejarah Alat Pemadam Api',
    view_engine_history: 'Lihat Sejarah Enjin',
    engine_history: 'Sejarah Enjin',
    prime_mover_vehicle: 'Kenderaan Prime Mover',
    view_insurance_history: 'Lihat Sejarah Kelayakan',
    insurance_history: 'Sejarah Kelayakan',
    view_pma_history: 'Lihat Sejarah PMA',
    pma_history: 'Sejarah PMA',
    please_apply_filter_first: 'Silakan lakukan filter terlebih dahulu',
    interval_minute: 'Selang Waktu (Minit)',
    source_mode: 'Mod Sumber',
    peripheral: 'Peranti Luaran',
    new_lite_user: 'Pengguna Lite Baru',
    email_notification_update_report: 'Laporan Pemberitahuan E-mel',
    hourly_vehicle_update: 'Pembaruan Kenderaan Setiap Jam',
    vehicle_visibility: 'Keterlihatan Kenderaan',
    day_available: 'Hari Tersedia',
    time_range: 'Julat Masa',
    select_vehicle_to_set_user_visibility: 'Pilih Kenderaan Untuk Tetapkan Keterlihatan Pengguna',
    selected_vehicle_list: 'Senarai Kenderaan Terpilih',
    datetime: 'Tarikh/Masa',
    fuel_litre: 'Liter Bahan Api/%',
    temperature1: 'Suhu °C',
    temperature2: 'Suhu 2 °C',
    located: 'Lokasi',
    not_located: 'Tidak Lokasi',
    voltageV: 'Voltan (v)',
    latlng: 'Lat.Lng.',
    fixed: 'Tetap',
    none: 'Tidak ada',
    left: 'Kiri',
    right: 'Kanan',
    select_a_template: 'Pilih Templat',
    rename_template: 'Ubah Nama Templat',
    create_new_template: 'Buat Templat Baru',
    show_all_column: 'Tampilkan Semua Kolom',
    company_template: 'Templat Perusahaan',
    editable: 'Boleh Diedit',
    set_as_default: 'Tetapkan sebagai Lalai',
    share_across_other: 'Bagikan Sebagai Lain',
    field_chooser: 'Pemilih Kolom',
    delete_template: 'Padam Templat',
    create_template: 'Buat Templat',
    update_template: 'Perbaharui Templat',
    please_enter_template_name: 'Sila Masukkan Nama Templat',
    please_select_a_template_first: 'Sila Pilih Templat Pertama',
    view: 'Lihat',
    single_date: 'Tanggal Tunggal',
    specific_date: 'Tanggal Tertentu',
    confirm: 'Sahkan',
    NA: 'N/A',
    command: 'Perintah',
    raw: 'Mentah',
    antenna_status: 'Status Antena',
    received_time: 'Masa Diterima',
    layout: 'Tata Letak',
    selected: 'Dipilih',
    select_a_alert_type: 'Pilih Jenis Amaran',
    type_of_maintenance_job: 'Jenis Kerja Penyelenggaraan',
    odometer_mileage: 'jarak tempuh odometer(km)',
    new_service: 'Layanan Baru',
    due_soon: 'Tunggu Sampai',
    at_least_characters: 'Minimal %{num} karakter',
    new_maintenance_form: 'Borang Penyelenggaraan Baharu',
    planned: 'Terancang',
    unplanned: 'Tidak Dirancang',
    print: 'Cetak',
    rating: 'Penilaian',
    rate_n_review: 'Penilaian & Ulasan',
    contact_no2: 'No. Hubungi 2',
    workshop_profile: 'Profil Bengkel',
    status_changed: 'Status Bertukar',
    cancel_status_change: 'Batal Status Bertukar',
    ranger: 'Renjer',
    profile_image: 'Imej Profil',
    allowance: 'Elaun',
    commission: 'Komisen',
    charge_type: 'Jenis Caj',
    trip_date: 'Tarikh Perjalanan',
    new_training_record: "Rekod Latihan Baharu",
    new_violation_record: "Rekod Pelanggaran Baharu",
    new_trip_cost: 'Kos Perjalanan Baharu',
    summon: 'Saman',
    company_rule: 'Peraturan Syarikat',
    complaint: 'Aduan',
    create_training_record: 'Cipta Rekod Latihan',
    update_training_record: 'Kemas Kini Rekod Latihan',
    delete_training_record: 'Padam Rekod Latihan',
    delete_failed: 'Gagal Memadam',
    create_trip_cost: 'Cipta Kos Perjalanan',
    update_trip_cost: 'Kemas Kini Kos Perjalanan',
    delete_trip_cost: 'Padam Kos Perjalanan',
    unexpected_error: 'Ralat Tidak Dijangka',
    create_violation_record: 'Cipta Rekod Pelanggaran',
    update_violation_record: 'Kemas Kini Rekod Pelanggaran',
    delete_violation_record: 'Padam Rekod Pelanggaran',
    invoice_no: 'Nombor Invois',
    excel_import: 'Import Excel',
    add_new_service_record: 'Tambah Rekod Perkhidmatan Baharu',
    last_machinery_hour: 'Waktu Jentera Terakhir (jam)',
    item_code: 'Kod Item',
    tax: 'Cukai',
    new_category: 'Kategori Baharu',
    add_log: 'Tambah Log',
    service_log_details: 'Butiran Log Perkhidmatan',
    attachments_upload_on_save: 'Lampiran akan dimuat naik apabila anda menyimpan rekod.',
    attachment_upload_hint: 'Muat naik sehingga 10 fail (PDF atau imej, maksimum 15MB setiap satu).',
    choose_file: 'Pilih Fail',
    attachment_file_size_exceeds_limit: 'Saiz fail melebihi had (15MB)',
    max_attachments_exceeded: 'Maksimum 10 lampiran dibenarkan',
    upload_failed: 'Muat naik gagal',
    please_add_log: 'Sila tambah log di sini',
    enter: 'Masukkan data',
    add_new_category: 'Tambah Kategori Baharu',
    tracking: 'Penjejakan',
    enable_tracking_to_trace_expiry: 'Dayakan penjejakan untuk mengesan tamat tempoh penyelenggaraan',
    edit_record: 'Edit Rekod',
    maintenance_profile: 'Profil Penyelenggaraan',
    vehicle_service_log_report: 'Laporan Log Servis Kenderaan',
    select_group: 'Pilih Kumpulan',
    select_category: 'Pilih Kategori',
    select_document_type: 'Pilih Jenis Dokumen',
    select_device_type: 'Pilih Jenis Peranti',
    select_protocol_type: 'Pilih Jenis Protocol',
    please_select_energy_source: 'Sila Pilih Sumber Enjin',
    please_select_permanent: 'Sila Pilih Permanen',
    net_total: 'Jumlah Bersih',
    ledger_balance: 'Baki Lejar',
    ending_mileage: 'Mileage Akhir',
    total_mileage: 'Jumlah Mileage',
    category_required: 'Kategori diperlukan!',
    geofence_name: 'Nama Geofence',
    create_lite_access: 'Buat Akses Lite',
    update_lite_access: 'Perbarui Akses Lite',
    used_for_immobilization_rfid_setup: '(Digunakan untuk Immobilisasi, RFID Setup)',
    please_enter_role_name: 'Sila Masukkan Nama Peranan',
    please_enter_package_name: 'Sila Masukkan Name Package',
    one_number_required: "Satu huruf angka diperlukan.",
    one_lowercase_required: "Satu huruf huruf kecil diperlukan.",
    one_uppercase_required: "Satu huruf huruf besar diperlukan.",
    one_symbol_required: "Satu simbol diperlukan.",
    minimum_eight: "Minimal 8 karakter.",
    please_enter_workshop_name: 'Sila Masukkan Nama Workshop',
    please_enter_contact_person: 'Sila Masukkan Contact Person',
    please_enter_address: 'Sila Masukkan Alamat',
    please_enter_latitude: 'Sila Masukkan Latitude',
    please_enter_longitude: 'Sila Masukkan Longitude',
    please_enter_latitude_and_longitude: 'Sila masukkan latitud dan longitud',
    please_choose_type: 'Sila Pilih Jenis',
    please_enter_training_title: 'Sila Masukkan Tajuk Pelatihan',
    please_select_attended_date: 'Sila Pilih Tarikh Hadir',
    please_select_violation_type: 'Sila Pilih Jenis Pelanggaran',
    please_select_violation_date: 'Sila Pilih Tarikh Pelanggaran',
    please_enter_violation_description: 'Sila Masukkan Penerangan Pelanggaran',
    this_record: 'rekod ini',
    please_select_charge_type: 'Sila Pilih Jenis Caj',
    please_select_trip_date: 'Sila Pilih Tarikh Perjalanan',
    excel_template: 'Templat Excel',
    please_upload_with_the_download_xlsx_template_file: 'Sila muat naik dengan fail templat xlsx yang dimuat turun',
    drop_file_here: 'Muat Naik fail disini',
    or: 'Atau',
    upload_error: 'Ralat Muat Naik',
    import_fail_try_again: 'Import Gagal, Sila Cuba Lagi',
    please_download_template_and_use_this_template_for_upload: 'Sila Muat Turun Templat dan Gunakannya untuk Muat Naik',
    download_template: 'Muat turun Templat',
    upload_file_template_to_import: 'Muat Naik Templat Fail Untuk Import',
    service_record_imported: 'Rekod Perkhidmatan Diimport',
    service_log_imported: 'Log Perkhidmatan Diimport',
    total_fleet_maintenance_cost: 'Jumlah Kos Penyelenggaraan Armada',
    please_select_one_vehicle: 'Sila Pilih Satu Kendaraan',
    please_select_drive_in_datetime: 'Sila Pilih Tarikh Masuk',
    please_select_job_type: 'Sila Pilih Jenis Jabatan',
    create_maintenance_form: 'Buat Borang Penyelenggaraan',
    update_maintenance_form: 'Perbaharui Borang Penyelenggaraan',
    delete_maintenance_form: 'Padam Borang Penyelenggaraan',
    create_maintenance_service: 'Buat Perkhidmatan Penyelenggaraan',
    update_maintenance_service: 'Perbaharui Perkhidmatan Penyelenggaraan',
    delete_service_record: 'Padam Rekod Perkhidmatan',
    update_on: 'Dikemaskini Pada',
    this_year: 'Tahun Ini',
    last_year: 'Tahun Lepas',
    increase_to_previous_year: 'meningkat kepada tahun sebelumnya',
    reduce_to_previous_year: 'kurangkan kepada tahun sebelumnya',
    increase_to_previous_month: 'meningkat kepada bulan sebelumnya',
    reduce_to_previous_month: 'kurangkan kepada bulan sebelumnya',
    either_date_or_mileage_required: 'Sama ada Tarikh atau Perbatuan Mampu Mileage Diperlukan untuk Penjejakan',
    import_successful: 'Import Berjaya',
    close: 'Tutup',
    not_yet_setup: 'Belum Tersedia',
    uploading: 'Memuat naik...',
    please_wait: 'Sila Tunggu',
    api_username: 'Name Pengguna API',
    api: 'API',
    please_select_efficient_date: 'Sila pilih tarikh efektif',
    please_select_at_least_one_vehicle: 'Sila pilih setidaknya satu kendaraan',
    update_workshop_form: 'Kemas kini Borang Bengkel',
    create_workshop: 'Tambah Bengkel',
    peripheral_name_is_required: 'Nama Periferal Diperlukan',
    select_a_peripheral_type: 'Pilih Jenis Periferal',
    select_an_api_integration: 'Pilih Integrasi API',
    enter_device_id: 'Masukkan ID Peranti',
    peripheral_device_name: 'Nama Peranti Periferal',
    peripheral_type: 'Jenis Periferal',
    api_integration: 'Integrasi API',
    tied_vehicle: 'Kenderaan Terikat',
    primary_peripheral: 'Pertama',
    general_peripheral: 'Baisa',
    peripheral_device: 'Peranti Periferal',
    new_peripheral_device: 'Peranti Periferal Baharu',
    created_peripheral_device: 'Peranti Periferal Telah Dicipta',
    updated_peripheral_device: 'Peranti Periferal Telah Dikemas Kini',
    deleted_peripheral_device: 'Peranti Periferal Telah Dihapuskan',
    delete_peripheral_device: 'Padam Peranti Periferal',
    new_api_integration: 'Integrasi API Baharu',
    add_peripheral_api: 'Tambah API Periferal',
    edit_peripheral_api: 'Sunting API Periferal',
    api_name_is_required: 'Nama API Diperlukan',
    select_an_api: 'Pilih API',
    created_peripheral_api: 'API Periferal Telah Dicipta',
    updated_peripheral_api: 'API Periferal Telah Dikemas Kini',
    deleted_peripheral_api: 'API Periferal Telah Dihapuskan',
    delete_peripheral_api: 'Padam API Periferal',
    average_driver_safety_score: 'Skor Keselamatan Pemandu Purata',
    average_vehicle_safety_score: 'Skor Keselamatan Kenderaan Purata',
    driver_safety_score_distribution: 'Taburan Skor Keselamatan Pemandu',
    vehicle_safety_score_distribution: 'Taburan Skor Keselamatan Kenderaan',
    based_on_previous_day: 'Berdasarkan Hari Sebelumnya',
    company_target_score_line: 'Garis Skor Sasaran Syarikat',
    company_score_baseline: 'Garis Asas Skor Syarikat',
    hos_compliance_score: 'Skor Pematuhan HOS',
    driving_behaviour_score: 'Skor Tingkah Laku Pemanduan',
    compared_to_previous_month: 'Berbanding Bulan Sebelumnya',
    score_: 'Skor(%)',
    total_safety_events: 'Jumlah Kejadian Keselamatan',
    overspeeding: 'Memandu Melebihi Had Laju',
    harsh_braking: 'Brek Mengejut',
    harsh_acceleration: 'Pecutan Mengejut',
    harsh_cornering: 'Membelok Mengejut',
    safety_event_distribution: 'Taburan Kejadian Keselamatan',
    safety_events_by_map: 'Kejadian Keselamatan Mengikut Peta',
    safety_events_chart: 'Carta Kejadian Keselamatan',
    safety_event_number: 'Nombor Kejadian Keselamatan',
    ovs: 'OVS',
    ha: 'HA',
    hb: 'HB',
    hc: 'HC',
    vehicle_safety_analytics: 'Analitik Keselamatan Kenderaan',
    vehicle_performance_status: 'Status Prestasi Kenderaan',
    top_5_scoring_vehicles: '5 Kenderaan Skor Tertinggi',
    bottom_5_low_scoring_vehicles: '5 Kenderaan Skor Terendah',
    score_distribution_driving_behaviour: 'Taburan Skor (Tingkah Laku Pemanduan)',
    score_distribution_vehicle: 'Taburan Skor (Kenderaan)',
    top_5_overspeeding_vehicle: '5 Kenderaan Paling Laju',
    top_5_harsh_acceleration_vehicle: '5 Kenderaan Pecutan Mengejut Tertinggi',
    top_5_harsh_braking_vehicle: '5 Kenderaan Brek Mengejut Tertinggi',
    top_5_harsh_cornering_vehicle: '5 Kenderaan Membelok Mengejut Tertinggi',
    top_5_scoring_driver: '5 Pemandu Skor Tertinggi',
    bottom_5_low_scoring_driver: '5 Pemandu Skor Terendah',
    top_5_overspeeding_driver: '5 Pemandu Paling Laju',
    top_5_harsh_acceleration_driver: '5 Pemandu Pecutan Mengejut Tertinggi',
    top_5_harsh_braking_driver: '5 Pemandu Brek Mengejut Tertinggi',
    top_5_harsh_cornering_driver: '5 Pemandu Membelok Mengejut Tertinggi',
    top_5_mobile_usage_driver: '5 Pemandu Paling Guna Telefon Bimbit',
    top_5_adas_bsm_driver: '5 Pemandu ADAS/BSM Skor Tertinggi',
    top_5_fatigue_driver: '5 Pemandu Pemandu Paling Letih',
    top_5_closed_eye_driver: '5 Pemandu Pemandu Mata Tertutup',
    top_5_distracted_driving_driver: '5 Pemandu Pemanduan Terganggu Tertinggi',
    safety_events_report: 'Laporan Kejadian Keselamatan',
    view_report: 'Lihat Laporan',
    safety_event: 'Kejadian Keselamatan',
    vehicle_performance_report: 'Laporan Prestasi Kenderaan',
    vehicle_safety_score: 'Skor Keselamatan Kenderaan',
    performance_status: 'Status Prestasi',
    ai_safety_score: 'Skor Keselamatan AI',
    fleet_safety_analytics: 'Analitis Keselamatan Armada',
    total_event: 'Jumlah Acara',
    total_driver: 'Jumlah Pemandu',
    driving_behaviour_event: 'Kejadian Tingkah Laku Pemanduan',
    ai_safety_event: 'Kejadian Keselamatan AI',
    active_safety: 'Keselamatan Aktif (ADAS)',
    blind_spot_monitoring: 'Pemantauan Titik Buta (BSM)',
    driver_safety_monitoring: 'Pemantauan Keselamatan Pemandu (DSM)',
    ai_powered_vehicle_risk_level: 'Tahap Risiko Kenderaan Dikuasakan AI',
    adas: 'ADAS',
    bsm: 'BSM',
    dsm: 'DSM',
    high_risk: 'Risiko Tinggi',
    medium_risk: 'Risiko Sederhana',
    low_risk: 'Risiko Rendah',
    no_risk: 'Tiada Risiko',
    total_ai_safety_events: 'Jumlah Kejadian Keselamatan AI',
    top_5_mobile_usage_vehicle: '5 Kenderaan Paling Guna Telefon Bimbit',
    top_5_fatigue_vehicle: '5 Kenderaan Pemandu Paling Letih',
    top_5_closed_eye_vehicle: '5 Kenderaan Pemandu Mata Tertutup',
    top_5_distracted_driving_vehicle: '5 Kenderaan Pemanduan Terganggu Tertinggi',
    number_of_event: 'Nombor Acara',
    api_type: 'Jenis API',
    api_name: 'Nama API',
    select_a_timezone: 'Pilih Zon Waktu',
    please_update_your_password: 'Sila Kemaskini Kata Laluan Anda',
    review_status: 'Status Semakan',
    speed_range: 'Julat Kelajuan',
    video_view: 'Paparan Video',
    mark_as_false_positive: 'Tanda Sebagai Positif Palsu',
    false_positive: 'Positif Palsu',
    acknowledged: 'Telah Diterima',
    acknowledge: 'Terima',
    review_updated: 'Semakan Dikemas Kini',
    cancel_acknowledge: 'Batal Penerimaan',
    vehicle_performance_summary: 'Ringkasan Prestasi Kenderaan',
    vehicle_behaviour_score: 'Skor Tingkah Laku Kenderaan',
    vehicle_performance_details: 'Butiran Prestasi Kenderaan',
    count_of_violation: 'Bilangan Pelanggaran',
    hos_compliance: 'Pematuhan HOS',
    vehicle_behaviour: 'Tingkah Laku Kenderaan',
    ai_safety: 'Keselamatan AI',
    event_details: 'Butiran Kejadian',
    advance_only: 'Adv. Shj.',
    overview: 'Gambaran Keseluruhan',
    driver_safety_score: 'Skor Keselamatan Pemandu',
    safety_event_detail: 'Butiran Kejadian Keselamatan',
    watch_evidence: 'Tonton Bukti',
    based_on: 'Berdasarkan',
    top_5_adas_bsm_vehicle: '5 Kenderaan ADAS/BSM Skor Tertinggi',
    score_distribution_ai_safety: 'Taburan Skor (Keselamatan AI)',
    no_evidence: 'Tiada Bukti',
    play_from_device: 'Main dari Peranti',
    device_offline: 'Sila tunggu peranti dalam talian untuk melihat bukti',
    peripheral_device_not_online: 'Peranti periferal tidak dalam talian, sila tunggu peranti dalam talian untuk pratonton bukti',
    checking_evidence: 'Memeriksa Bukti',
    speeding_range: 'Julat Kelajuan Berlebihan',
    speeding_limit: 'Had Laju',
    company_settings: 'Tetapan Syarikat',
    safety_target_score: 'Skor Sasaran Keselamatan',
    safety_baseline_score: 'Skor Asas Keselamatan',
    driver_safety_score_baseline: 'Skor Asas Keselamatan Pemandu',
    hos_weight: 'Berat Pematuhan HOS',
    checklist_weight: 'Berat Senarai Semak',
    summon_weight: 'Berat Saman',
    advanced_overspeed_weight: 'Berat Pemanduan Melebihi Had Laju',
    advance_harsh_acceleration_weight: 'Berat Pecutan Mengejut',
    advance_harsh_deceleration_weight: 'Berat Nyahpecutan Mengejut',
    advance_harsh_turning_weight: 'Berat Membelok Mengejut',
    sv_fatigue_weight: 'Berat Keletihan',
    sv_mobile_smoking_weight: 'Berat Penggunaan Telefon / Merokok',
    sv_distracted_driving_weight: 'Berat Pemanduan Terganggu',
    sv_adas_bsm_weight: 'Berat ADAS / BSM',
    aiSafety_adas_weight: 'Berat ADAS Keselamatan AI',
    aiSafety_dsm_weight: 'Berat DSM Keselamatan AI',
    aiSafety_bsm_weight: 'Berat BSM Keselamatan AI',
    driving_behavour: 'Perilaku Kereta',
    basic: 'Asas',
    advance: 'Lanjutan',
    overspeed_weight: 'Berat Melebihi Had Laju',
    harsh_acceleration_weight: 'Berat Pecutan Mengejut',
    harsh_deceleration_weight: 'Berat Nyahpecutan Mengejut',
    harsh_turning_weight: 'Berat Membelok Mengejut',
    checklist_template_name: 'Nama Templat Senarai Semak',
    default_checklist: 'Senarai Semak Lalai',
    customized_checklist: 'Senarai Semak Disesuaikan',
    e_signature: 'Tandatangan Elektronik',
    tick_all_items_section: 'Tanda Semua Item Dalam Seksyen',
    checklist_section: 'Seksyen Senarai Semak',
    add_template_item: 'Tambah Item Templat',
    add_section: 'Tambah Seksyen',
    add_section_to_start_customizing_your_checklist: 'Tambah Seksyen untuk Mula Menyesuaikan Senarai Semak Anda',
    customized_your_own_checklist_template: 'Sesuaikan Templat Senarai Semak Anda Sendiri',
    checklist_item: 'Item Senarai Semak',
    add_checklist_item: 'Tambah Item Senarai Semak',
    real_time_safety_alert: 'Amaran Keselamatan Masa Sebenar',
    driving_behaviour_alert: 'Amaran Tingkah Laku Pemanduan',
    notify_driver: 'Maklumkan Pemandu',
    ai_safety_alert: 'Amaran Keselamatan AI',
    high_risk_to_low_risk: 'Risiko Tinggi ke Risiko Rendah',
    low_risk_to_high_risk: 'Risiko Rendah ke Risiko Tinggi',
    driver_safety_montoring: 'Pemantauan Keselamatan Pemandu',
    blind_spot_montoring: 'Pemantauan Titik Buta',
    import_template: 'Import Templat',
    new_checklist_template: 'Templat Senarai Semak Baharu',
    are_you_sure_delete_this_record: 'Adakah anda pasti memadam rekod ini?',
    driver_configuration_name: 'Nama Konfigurasi Pemandu',
    checklist_type: 'Jenis Senarai Semak',
    checklist_template_settings: 'Tetapan Templat Senarai Semak',
    set_the_checklist_template_to_drivers: 'Tetapkan Templat Senarai Semak kepada Pemandu',
    checklist_template: 'Templat Senarai Semak',
    frequency: 'Kekerapan',
    reminder_notification: 'Pemberitahuan Peringatan',
    add_checklist_template: 'Tambah Templat Senarai Semak',
    checklist_group_configuration: 'Konfigurasi Kumpulan Senarai Semak',
    please_assign_driver_to_set_configuration: 'Sila Tetapkan Pemandu untuk Menetapkan Konfigurasi',
    exceeded_rest_time_reminder_notification: 'Pemberitahuan Peringatan Melebihi Masa Rehat',
    module_reminder_settings: 'Tetapan Modul/Peringatan',
    exceeded_working_time_reminder_notification: 'Pemberitahuan Peringatan Melebihi Masa Bekerja',
    loading_discharge_module: 'Modul Memuatkan/Pemunggahan',
    exceeded_loading_time_reminder_notification: 'Pemberitahuan Peringatan Melebihi Masa Memuatkan',
    exceeded_discharge_time_reminder_notification: 'Pemberitahuan Peringatan Melebihi Masa Pemunggahan',
    loading_discharge_waiting_module: 'Modul Menunggu Memuatkan/Pemunggahan',
    new_checklist_item: 'Item Senarai Semak Baharu',
    set_checklist_item_as: 'Tetapkan Item Senarai Semak Sebagai',
    mandatory: 'Wajib',
    english: 'Inggeris',
    malay: 'Melayu',
    chinese: 'Cina',
    indonesian: 'Indonesia',
    checklist_element: 'Elemen Senarai Semak',
    check_mark_field: 'Semak Medan Tanda',
    text_field: 'Medan Teks',
    numeric_field: 'Medan Nombor',
    icon: 'Ikon',
    attachment_and_remark: 'Lampiran & Ulasan',
    preview_of_driver_care_checklist_items: 'Pratonton Item Senarai Semak Penjagaan Pemandu',
    other_languages: 'Bahasa Lain',
    created_on: 'Dicipta Pada',
    element: 'Unsur',
    new_driver_configuration: 'Konfigurasi Pemandu Baharu',
    day_required: 'Hari Diperlukan',
    frequency_required: 'Kekerapan Diperlukan',
    checklist_template_required: 'Templat Senarai Semak Diperlukan',
    driver_configuration_name_is_required: 'Nama Konfigurasi Pemandu Diperlukan',
    validation: 'Pengesahan',
    min_character_length: 'Panjang Aksara Minimum',
    max_character_length: 'Panjang Aksara Maksimum',
    min_value: 'Nilai Minimum',
    max_value: 'Nilai Maksimum',
    max_decimal_place: 'Tempat Perpuluhan Maksimum',
    system_default: 'Lalai Sistem',
    daily: 'Harian',
    select_a_frequency_first: 'Pilih Kekerapan Dahulu',
    driver_configuration_details: 'Butiran Konfigurasi Pemandu',
    exceeded_rest_time_remainder_notification: 'Peringatan Masa Rehat Melebihi Had',
    last_updated_on: 'Kemas Kini Terakhir Pada',
    reminder_notification_time: 'Masa Peringatan Pemberitahuan',
    delete_driver_configuration: 'Padam Konfigurasi Pemandu',
    update_driver_configuration: 'Kemas Kini Konfigurasi Pemandu',
    create_driver_configuration: 'Cipta Konfigurasi Pemandu',
    new_supplier: 'Penyedia Baru',
    create_supplier: 'Cipta Penyedia',
    update_supplier: 'Kemas Kini Penyedia',
    delete_supplier: 'Padam Penyedia',
    edit_checklist_item: 'Sunting Item Senarai Semak',
    new_item_code: 'Kode Item Baru',
    create_item_code: 'Cipta Kode Item',
    update_item_code: 'Kemas Kini Kode Item',
    delete_item_code: 'Padam Kode Item',
    checklist_template_name_is_required: 'Nama Templat Senarai Semak Diperlukan',
    description_is_required: 'Penerangan Diperlukan',
    please_add_at_least_one_section: 'Sila tambah sekurang-kurangnya satu seksyen.',
    please_select_an_item: 'Sila Pilih Item',
    enter_section_name: 'Masukkan Nama Seksyen',
    section_name_is_required: 'Nama Seksyen Diperlukan',
    add_new: 'Tambah Baru',
    no_option: 'Tiada Opsyen',
    quantity: 'Kuantiti',
    subtotal: 'Subtotal',
    service_record_details: 'Butiran Rekod Perkhidmatan',
    unit_price: 'Harga Unit',
    total_amount: 'Jumlah Keseluruhan',
    driver_check_in_out_record: 'Rekod Daftar Masuk/Keluar Pemandu',
    driver_status_monitor_board: 'Papan Pemantauan Status Pemandu',
    status_time: 'Masa Status',
    working_duration: 'Tempoh Bekerja',
    resting_duration: 'Tempoh Rehat',
    discharge_duration: 'Tempoh Pembuangan',
    loading_duration: 'Tempoh Memuatkan',
    havent_checked_in_out: 'Belum Daftar Masuk/Keluar',
    all_pass: 'Lulus Semua',
    failed: 'Gagal',
    form_id: 'ID Borang',
    approved: 'Diluluskan',
    pending: 'Menunggu Kelulusan',
    form: 'Borang',
    are_you_sure_you_want_to_approve_this_checklist: 'Adakah anda pasti mahu meluluskan senarai semak ini?',
    approval_confirmation: 'Pengesahan Kelulusan',
    '7_days': '7 Hari Terakhir',
    custom: 'Tersuai',
    clone_template: 'Klon Templat',
    checklist_completion: 'Penyiapan Senarai Semak',
    checklist_record: 'Rekod Senarai Semak',
    checklist_creation_time: 'Masa Ciptaan Senarai Semak',
    this_week: 'Minggu Ini',
    checklist_completion_list: 'Senarai Penyiapan Senarai Semak',
    total_checklist: 'Jumlah Senarai Semak',
    delete_checklist_template: 'Padam Templat Senerai Semak',
    checklist_report: 'Laporan Senarai Semak',
    condition: 'Keadaan',
    available: 'Tersedia',
    unavailable: 'Tidak Tersedia',
    create_checklist_template: 'Cipta Templat Senarai Semak',
    update_checklist_template: 'Kemaskini Templat Senarai Semak',
    apad_print: 'Cetakan APAD',
    checklist_approval_report: 'Laporan Kelulusan Senarai Semak',
    please_set_a_duration_for_the_link: 'Sila tetapkan tempoh untuk pautan',
    activate_time: 'Masa Aktif',
    use_current_time: 'Gunakan Masa Semasa',
    show_speed: 'Tunjukkan Kelajuan',
    show_sensor_info: 'Tunjukkan Maklumat Sensor',
    create_link: 'Cipta Pautan',
    created_link: 'Pautan Dicipta',
    done: 'Selesai',
    start_date_time: 'Tarikh/Masa Mula',
    end_date_time: 'Tarikh/Masa Tamat',
    manage_sharable_link: 'Urus Pautan Boleh Dikongsi',
    link_type: 'Jenis Pautan',
    deactivate_link: 'Nyahaktifkan Pautan',
    deactivated_link: 'Pautan Dinyahtaktifkan',
    delete_sharable_link: 'Padam Pautan Boleh Dikongsi',
    deleted_sharable_link: 'Pautan Boleh Dikongsi Dipadam',
    link_copied_to_clipboard: 'Pautan disalin ke papan klip!',
    failed_to_copy_link: 'Gagal menyalin pautan.',
    no_link_found_to_copy: 'Tiada pautan untuk disalin.',
    copy: 'Salin',
    stop_sharing: 'Hentikan Perkongsian',
    allow_sharing: 'Benarkan Perkongsian',
    create_sharable_link: 'Cipta Pautan Boleh Dikongsi',
    share: 'Kongsi',
    generate_link: 'Jana Pautan',
    please_select_channels: '*Sila pilih saluran',
    cancel_share: 'Batal Kongsi',
    sharable_live_video: 'Video Langsung Boleh Dikongsi',
    eta: 'Anggaran Masa Tiba (ETA)',
    terminate_link: 'Tamatkan Pautan',
    permanent_removal_warning: 'Setelah ditamatkan, akses ini akan dipadam secara kekal!',
    terminate: 'Tamatkan',
    sharable_link_tracking: 'Penjejakan Pautan Boleh Dikongsi',
    activated_link: 'Pautan Diaktifkan',
    active_link_to_allow_sharing: 'Pautan Aktif untuk Membenarkan Perkongsian',
    sharable_link_generated: 'Pautan Boleh Dikongsi Dihasilkan',
    odometer_km: 'Odometer (KM)',
    bill_rm: 'Bil (RM)',
    bill_l: 'Bil (L)',
    bill_rate: 'Kadar Bil (RM/L)',
    before_refuel_l: 'Sebelum Isi Minyak (L)',
    after_refuel: 'Selepas Isi Minyak (L)',
    auto_refuel: 'Isian Minyak Automatik',
    '+-_l': '+/- (L)',
    '+-_rm': '+/- (RM)',
    travel_distance_km: 'Jarak Perjalanan (KM)',
    accuracy: 'Ketepatan (%)',
    import_refuel_records: 'Import Rekod Isian Minyak',
    excel_file_upload: 'Muat Naik Fail Excel',
    no_file: 'Tiada Fail',
    refuel_record: 'Rekod Isian Minyak',
    refuel_records: 'Rekod Isian Minyak',
    upload_file_first: 'Sila muat naik fail terlebih dahulu',
    create_record: 'Cipta Rekod',
    import: 'Import',
    sync_from_fms: 'Segerakkan dari FMS',
    edit_table_data: 'Edit Data Jadual',
    gas_station: 'Stesen Minyak',
    refuel_detail: 'Butiran Isian Minyak',
    fuel_price_rm: 'Harga Minyak (RM)',
    fuel_rate_rm_l: 'Kadar Minyak (RM/L)',
    fuel_amount_l: 'Jumlah Minyak (L)',
    please_fill_all_required_columns_before_using: 'Sila isi semua ruangan yang diperlukan sebelum digunakan',
    variation: 'Variasi',
    check: 'Semak',
    select_file: 'Pilih Fail',
    file_limit_is_1_selected: 'Had Fail ialah 1. Dipilih:',
    files: 'Fail.',
    delete_to_upload_new_file: 'Padam Untuk Muat Naik Fail Baharu',
    cancel_the_transfer_of: 'Batalkan Pemindahan',
    select_a_datetime: 'Pilih Tarikh/Masa',
    key_in_a_location: 'Masukkan Lokasi',
    select_a_gas_station: 'Pilih Stesen Minyak',
    fuel_price_is_required: 'Harga Minyak diperlukan',
    fuel_rate_is_required: 'Kadar Minyak diperlukan',
    fuel_amount_is_required: 'Jumlah Minyak diperlukan',
    delete_refuel_record: 'Padam Rekod Isian Minyak',
    delete_system_auto_refuel_confirmation: 'Pengesahan Padam Isian Minyak Automatik Sistem',
    are_you_sure_delete_system_auto_refuel: 'Adakah anda pasti mahu padam rekod isian minyak automatik sistem ini?',
    delete_system_auto_refuel_success: 'Rekod isian minyak automatik sistem berjaya dipadam',
    create_refuel_record: 'Cipta Rekod Isian Minyak',
    update_refuel_record: 'Kemaskini Rekod Isian Minyak',
    page_will_close_in_seconds: 'Halaman ini akan ditutup dalam {seconds} saat.',
    refuel_report_will_be_refreshed: 'Laporan isian minyak akan dimuat semula.',
    refuel_record_insertion_confirmation: 'Pengesahan Masukkan Rekod Isian Minyak',
    are_you_sure_to_insert_bill: 'Adakah anda pasti mahu masukkan bil?',
    bill_litre_insertion: 'Masukkan Liter Bil',
    bill_litre_insertion_completed: 'Masukkan Liter Bil Selesai',
    insert_refuel_variation: 'Masukkan Variasi Isian Minyak',
    cancel_edit_or_insert_refuel_variation_to_continue: 'Sila batalkan edit atau masukkan variasi isian minyak untuk meneruskan.',
    some_drivers_or_vehicles_are_not_valid_please_select_valid_input_before_submitting: 'Sesetengah pemandu atau kenderaan tidak sah. Sila pilih input yang sah sebelum menghantar.',
    no_matched_or_selected_vehicle_for_refuel_import: 'Tiada kenderaan yang sepadan atau dipilih untuk rekod isian minyak tersebut, jadi tiada rekod isian minyak diimport ke dalam sistem.',
    cancel_edit: 'Batalkan Edit',
    data_not_in_system: '(Data Tiada Dalam Sistem)',
    refuel_record_insertion_completed: 'Penyisipan Rekod Isian Minyak Selesai',
    refuel_record_insertion: 'Penyisipan Rekod Isian Minyak',
    total_usage_l: 'Jumlah Penggunaan (L)',
    total_refuel_l: 'Jumlah Isian Minyak (L)',
    statical_time: 'Masa Statistik',
    litre_per_km: 'Liter per KM',
    average_fuel_consumption_km_l: 'Purata Penggunaan Minyak (KM/L)',
    fuel_analysis_chart: 'Carta Analisis Bahan Api',
    speed_analysis_chart: 'Carta Analisis Kelajuan',
    refuel_datetime: 'Tarikh/Masa Isian Minyak',
    minute_s: 'Minit',
    usage_l: 'Penggunaan (L)',
    rm_km: 'RM/KM',
    km_liter: 'KM/Liter',
    l_km: 'Liter/KM',
    fuel_l: 'Minyak (L)',
    idling_usage_l: 'Penggunaan Semasa Melahu (L)',
    idling_cost_rm: 'Kos Melahu (RM)',
    idling_time: 'Masa Melahu',
    total_journey_duration_hh_mm: 'Jumlah Tempoh Perjalanan (JJ:MM)',
    journey_time: 'Masa Perjalanan',
    liter_km: 'Liter/KM',
    vehicle_fuel_analysis: 'Analisis Penggunaan Minyak Kenderaan',
    total_liter_l: 'Jumlah Liter (L)',
    auto_refuel_rm: 'Isian Semula Automatik (RM)',
    auto_refuel_l: 'Isian Semula Automatik (L)',
    accuracy_perc: 'Ketepatan (%)',
    incl: 'Termasuk',
    excl: 'Tidak Termasuk',
    mismatch: 'Tidak Sejajar',
    km_per_liter: 'KM setiap Liter',
    liter_per_100km: 'Liter setiap 100KM',
    miles_per_gallon: 'Batu setiap Gelen',
    mileage_liter_by_statement_report: 'Jarak Perjalanan/Liter melalui Laporan Penyata',
    fuel_spend: 'Perbelanjaan Bahan Api',
    mark_as_valid: 'Tandakan sebagai Sah',
    mark_as_invalid: 'Tandakan sebagai Tidak Sah',
    refuel_details: 'Butiran Isian Minyak',
    fuel_dropped: 'Minyak Dijatuhkan',
    fuel_dropped_details: 'Butiran Minyak Dijatuhkan',
    dropped_fuel_litre_l: 'Liter Minyak Dijatuhkan (L)',
    dropped_fuel_percentage_perc: 'Peratusan Minyak Dijatuhkan (%)',
    validation_status: 'Status Pengesahan',
    valid: 'Sah',
    invalid: 'Tidak Sah',
    are_you_sure_you_want_to_mark_the_selected_rows_as_valid: 'Adakah anda pasti mahu menandakan baris yang dipilih sebagai sah?',
    are_you_sure_you_want_to_mark_the_selected_rows_as_invalid: 'Adakah anda pasti mahu menandakan baris yang dipilih sebagai tidak sah?',
    fuel_drop_marked: 'Penurunan Minyak Ditandakan',
    mark_fuel_drop: 'Tandakan Penurunan Minyak?',
    checklist_log: 'Log Senarai Semak',
    driver_configuration: 'Konfigurasi Pemandu',
    please_select_a_driver: 'Sila pilih pemandu',
    please_select_date_range: 'Sila pilih julat tarikh',
    your_passord_has_not_been_updated_in_over: 'Kata laluan anda belum dikemas kini selama lebih daripada',
    please_update_it_to_keep_your_account_secure: 'Sila kemas kini untuk memastikan akaun anda selamat',
    at_least_one_row_is_required: 'Sekurang-kurangnya satu baris diperlukan',
    select_a_billing_entity: 'Sila pilih entiti pengebilan',
    compare_to_last_7_days: 'Bandingkan dengan 7 Hari Terakhir',
    operating_days: 'Hari Operasi',
    compare_to_last_30_days: 'Bandingkan dengan 30 Hari Terakhir',
    compare_to_previous_period: 'Bandingkan dengan Tempoh Sebelumnya',
    total_violation_count: 'Jumlah Pelanggaran',
    total_checklist_count: 'Jumlah Senarai Semak',
    vehicle_idling_time_list: 'Senarai Masa Melahu Kenderaan',
    vehicle_high_speed_list: 'Senarai Kelajuan Tinggi Kenderaan',
    vehicle_high_fuel_consumption_list: 'Senarai Penggunaan Bahan Api Tinggi Kenderaan',
    vehicle_fuel_economy_list: 'Senarai Kecekapan Bahan Api Kenderaan',
    safety_driver_list: 'Senarai Pemandu Berhemah',
    high_risk_driver_list: 'Senarai Pemandu Berisiko Tinggi',
    check_all: 'Semak Semua',
    safevision_integrated: 'SafeVision Bersepadu',
    aircond: 'Aircond',
    end: 'Tamat',
    start: 'Mula',
    idle: 'Melahu',
    selected_but_did_not_press_ok: 'Anda memilih masa tetapi tidak menekan OK.',
    current_driver: 'Pemandu Semasa',
    assign_driver: 'Tetapkan Pemandu',
    unassign_driver: 'Nyah Tetapkan Pemandu',
    assigned_driver: 'Pemandu Ditetapkan',
    unassigned_driver: 'Pemandu Dinyahtetapkan',
    unassign_driver_by_leaving_blank: 'Nyahtugaskan Pemandu Dengan Meninggalkan Kosong',
    icop_compliance_score: 'Skor Pematuhan ICOP',
    icop_compliance: 'Pematuhan ICOP',
    checklist_compliance: 'Pematuhan Senarai Semak',
    count_of_completion: 'Kiraan Penyelesaian',
    summons: 'Saman',
    driver_performance_summary: 'Ringkasan Prestasi Pemandu',
    driver_performance_details: 'Butiran Prestasi Pemandu',
    accountType: {
        admin: 'Pentadbir Utama',
        support: 'Sokongan',
        partner: 'Rakan Kongsi',
        customer: 'Fleet Peribadi',
        fleet: 'Syarikat Fleet',
        merchant: 'Peniaga'
    },
    safety_score: 'Skor Keselamatan',
    icop_violation: 'Pelanggaran ICOP',
    driver_safety: 'Keselamatan Pemandu',
    vehicle_safety: 'Keselamatan Kenderaan',
    fuel_type: 'Jenis Bahan Api',
    total_distance_km: 'Jumlah Jarak (KM)',
    fuel_consumption_l: 'Penggunaan Bahan Api (L)',
    fuel_efficiency_l_km: 'Kecekapan Bahan Api (L/KM)',
    co2_emission_rate_kg_km: 'Kadar Pelepasan CO₂ (KG/KM)',
    co2_emmission_rate_fuel_kg_l: 'Kadar Pelepasan CO₂ / Bahan Api (KG/L)',
    esg_detail_report: 'Laporan Terperinci ESG',
    esg_report: 'Laporan ESG',
    esg_monthly_report: 'Laporan Bulanan ESG',
    esg: 'ESG',
    driver_safety_analytics: 'Analitik Keselamatan Pemandu',
    driver_performance_status: 'Status Prestasi Pemandu',
    score_distribution_icop_compliance: 'Taburan Skor (Pematuhan ICOP)',
    total_check_in_drivers: 'Jumlah Pemandu Daftar Masuk',
    complete: 'Lengkap',
    noComplete: 'Tidak Lengkap',
    driver_performance_report: 'Laporan Prestasi Pemandu',
    completed_the_checklist: 'Lengkapkan Senarai Semak',
    number_of_driver_check_in: 'Bilangan Daftar Masuk Pemandu',
    esg_detail: 'Butiran ESG',
    last_6_months: '6 Bulan Terakhir',
    use_month_range: 'Julat Bulan',
    use_date_range: 'Julat Tarikh',
    variation_checked: 'Variasi Disemak',
    please_ensure_there_is_datetime_vehicle_and_refuel_amount: 'Sila pastikan terdapat Tarikh/Masa, Kenderaan, dan Jumlah Isian Semula',
    vehicle_safety_events: 'Kejadian Keselamatan Kenderaan',
    vehicle_safety_event_score: 'Skor Kejadian Keselamatan Kenderaan',
    driver_signature: 'Tandatangan Pemandu',
    vehicle_usage: 'Penggunaan Kenderaan',
    vehicle_usage_record: 'Rekod Penggunaan Kenderaan',
    vehicle_usage_records: 'Rekod Penggunaan Kenderaan',
    vehicle_summary: 'Ringkasan Kenderaan',
    journey_summary: 'Ringkasan Perjalanan',
    transit: 'Transit',
    total_fuel_consumed: 'Jumlah Bahan Api Digunakan',
    fuel_refuel: 'Isi Minyak',
    duration_percent: 'Tempoh (%)',
    top_speed: 'Kelajuan Maksimum',
    fuel_wastage: 'Pembaziran Bahan Api',
    average_speed: 'Kelajuan Purata',
    create_new_user: 'Cipta Pengguna Baharu',
    owner_settings: 'Tetapan Pemilik',
    create_billing_entity: 'Cipta Entiti Bil',
    update_billing_entity: 'Kemaskini Entiti Bil',
    delete_billing_entity: 'Padam Entiti Bil',
    recover_engine_vehicle_control: 'Kawalan Enjin Pemulihan Kenderaan',
    stop_engine_vehicle_control: 'Kawalan Enjin Berhenti Kenderaan',
    please_enter_immobilizer_password_to_proceed_the_action: 'Sila masukkan kata laluan immobilizer untuk meneruskan tindakan',
    check_details: 'Semak Butiran',
    stop_engine: 'Berhenti Enjin',
    recover_engine: 'Memulih Enjin',
    vehicle_engine_stopping: 'Perintah berhenti enjin kenderaan kini dilaksanakan.',
    vehicle_engine_recovering: 'Perintah pemulihan enjin kenderaan kini dilaksanakan.',
    something_went_wrong: 'Berlaku ralat',
    authenticate_using_a_code_generated_by_an_app_installed_on_your_mobile_device_or_computer_to_increase_the_security_of_your_application: 'Sahkan menggunakan kod yang dijana oleh apl yang dipasang pada peranti mudah alih atau komputer anda untuk meningkatkan keselamatan aplikasi anda.',
    a_virtual_2fa_device_is_an_application_running_on_your_device_that_you_can_configure_by_scanning_a_qr_code: 'Peranti 2FA maya ialah aplikasi yang berjalan pada peranti anda yang boleh anda konfigurasikan dengan mengimbas kod QR.',
    install_a_compatible_application_such_as_google_authenticator_duo_mobile_or_authy_app_on_your_mobile_device_or_computer: 'Pasang aplikasi yang serasi seperti Google Authenticator, Duo Mobile atau apl Authy pada peranti mudah alih atau komputer anda.',
    this_account_has_enabled_two_factor_authentication_2fa: 'Akaun ini telah mengaktifkan otentikasi dua faktor (2FA).',
    this_account_has: 'Akaun ini telah',
    enabled: 'mengaktifkan',
    two_factor_authentication_2fa: 'Otentikasi Dua Faktor (2FA).',
    open_your_authenticator_app_scan_the_qr_code_or_enter_the_secret_key_manually: 'Buka apl autentikasi anda, imbas kod QR atau masukkan kunci rahasia secara manual',
    show_secret_key: 'Tunjukkan kunci rahasia',
    hide_secret_key: 'Sembunyikan kunci rahasia',
    two_factor_authentication: 'Otentikasi Dua Faktor',
    two_factor_authentication_2fa_authenticator_app: 'Apl Otentikasi Dua Faktor (2FA) Autentikasi',
    disable: 'Nyahaktifkan',
    please_enter_your_password_to_proceed_with_2fa_disabling: 'Sila masukkan kata laluan anda untuk meneruskan dengan nyahaktifkan 2FA',
    enter_your_password: 'Masukkan Kata Laluan anda',
    authentication_code: 'Kod Autentikasi',
    '2fa_disabled': '2FA Dihapuskan',
    '2fa_data_generated_please_verify_2fa_to_enable': 'Data 2FA Dihasilkan. Sila sahkan 2FA untuk mengaktifkan',
    setup_now: 'Setup Sekarang',
    please_enter_your_password_to_proceed_with_setup: 'Sila masukkan kata laluan anda untuk meneruskan dengan setup',
    set_up_two_factor_authentication_2fa: 'Setup Otentikasi Dua Faktor (2FA)',
    type_2fa_codes_shown_from_authenticator_app_below: 'Taipkan kod 2FA yang dipaparkan dari apl autentikasi di bawah',
    enable_now: 'Aktifkan Sekarang',
    '2fa_enabled': '2FA Dihidupkan',
    your_account_is_protected_with: 'Akaun anda dilindungi dengan',
    to_finish_signing_in_enter_the_code_from_your_authenticator_application_below: 'Untuk menyelesaikan masuk, masukkan kod dari apl autentikasi anda di bawah',
    '2fa_code': 'Kod 2FA',
    please_enter_valid_code: 'Sila masukkan kod yang sah',
    top_5_high_maintenance_cost: '5 Kenderaan Kekurangan Penyelenggaraan Tertinggi',
    video_preview: 'Pratonton Video',
    eventCategorySection: {
        advanceOverspeed: 'Kelajuan',
        advanceHarshDeceleration: 'Kelajuan Kelemahan',
        advanceHarshAcceleration: 'Kelajuan Akselerasi',
        advanceHarshTurning: 'Putaran Kelemahan',
        aiSafetyAdas: 'ADAS',
        aiSafetyDsm: 'DSM',
        aiSafetyBsm: 'BSM',
    },
    alert_records: 'Rekod Amaran',
    ago: 'lalu',
    reset_layout: 'Atur Ulang Tata Letak',
    travelled_duration: 'Durasi Perjalanan',
    travelled_distance_km: 'Jarak Perjalanan (KM)',
    zone: 'Zona',
    alarm_type: 'Jenis Alarm',
    alarm_level: 'Tahap Alarm',
    geofence_filter: 'Penapis Geofence',
    geofence_category: 'Kategori Geofence',
    geofence_category_management: 'Pengurusan Kategori Geofence',
    switch_to_create_mode: 'Tukar ke Mod Cipta',
    switch_to_edit_mode: 'Tukar ke Mod Edit',
    enable_password_expiring_mode: 'Aktifkan Mode Penghapusan Kata Laluan',
    reminder_only: 'Hanya Sisa',
    logout_after_expired: 'Keluar Setelah Kedaluwarsa',
    password_expiry_day: 'Tanggal Kedaluwarsa Kata Laluan',
    disabled: 'Dinonaktifkan',
    your_passord_will_expire_in: 'Kata laluan anda akan kedaluwarsa dalam',
    days_on: 'hari, Pada',
    please: 'Sila ',
    update_: 'kemas kini ',
    it_to_prevent_any_service_interruption: 'untuk mencegah perantian layanan',
    it_to_keep_your_account_secure: 'untuk menjaga akaun anda selamat',
    vehicle_drive_rest_report: 'Laporan Laju Drive Rest',
    rest_duration: 'Tempoh Rehat',
    driver_rest_report: 'Laporan Rehat Pemandu',
    total_driving_hour: 'Total Jam Pemulihan',
    total_rest_hour: 'Total Jam Berhenti',
    driving_time: 'Jam Pemulihan',
    resting_time: 'Jam Berhenti',
    duration_of_engine_on: 'Durasi Pembangkan',
    from_location: 'Dari Lokasi',
    to_location: 'Ke Lokasi',
    safety_alert_type: 'Jenis Peringatan Keselamatan',
    safety_alert_level: 'Tingkat Peringatan Keselamatan',
    safety_alert_description: 'Deskripsi Peringatan Keselamatan',
    export_historical_playback: 'Ekspor Main Balik Sejarah',
    one_day_ago: 'Satu Hari Sebelum',
    two_day_ago: 'Dua Hari Sebelum',
    three_day_ago: 'Tiga Hari Sebelum',
    highToLow: 'Risiko Tinggi ke Risiko Rendah',
    lowToHigh: 'Risiko Rendah ke Risiko Tinggi',
    internal_combustion_engine_vehicles: 'Kenderaan Mesin Api Internal',
    temperature_2: 'Suhu 2',
    temperature_3: 'Suhu 3',
    temperature_4: 'Suhu 4',
    best_in_class_fuel_efficiency: 'Kecekapan Bahan Api Penanda Aras Unggul',
    scope_overview: 'Pandangan Tinjauan',
    tailpipe_emissions: 'Emisi Tailpipe',
    carbon_emission: 'Emisi Karbon',
    fuel_cost_and_usage: 'Kos Harga & Penggunaan Bahan Api',
    potential_benchmark_savings: 'Potensi Penghematan Pengukuran',
    potential_best_in_class_savings: 'Potensi Penghematan Pengukuran Tingkat Tinggi',
    average_expenses: 'Kelayakan Rata-rata',
    fuel_cost: 'Kos Harga Bahan Api',
    average_fuel_economy: 'Kecekapan Bahan Api Rata-rata',
    average_benchmark_fuel_economy: 'Kecekapan Bahan Api Pengukuran Rata-rata',
    average_best_in_class_fuel_economy: 'Kecekapan Bahan Api Tingkat Tinggi Rata-rata',
    your_fleet: 'Fleet Anda',
    benchmark: 'Pengukuran',
    best_in_class: 'Tingkat Tinggi',
    CO2_emission: 'Emisi CO2',
    average_ice_fuel_economy: 'Kecekapan Bahan Api ICE Rata-rata',
    ton_metric_co2: 'Ton Metric CO2',
    vehicle_monthly_esg_performance_report: 'Laporan Kinerja Ekonomi Sistem Gas (ESG) Bulanan',
    avg_speed_km_h: 'Kecepatan Rata-rata (KM/H)',
    vehicle_journey_report: 'Laporan Kinerja',
    current_temperature: 'Suhu Semasa',
    battery_health: 'Kesehatan Baterai',
    engine_on_off: 'Pembangkan Diaktifkan/Nyahaktifkan',
    compressor_on_off: 'Kompresor Diaktifkan/Nyahaktifkan',
    cold_chain_analytics: 'Analisis Cold Chain',
    cold_chain_monitoring_dashboard: 'Papan Pemuka Monitor Cold Chain',
    front_compartment_alert: 'Amaran Ruang Depan',
    rear_compartment_alert: 'Amaran Ruang Belakang',
    critical_vehicle: 'Kenderaan Kritikal',
    offline_vehicle: 'Kenderaan Luar Talian',
    real_time_temperature_monitoring: 'Pemantauan Suhu Masa Nyata',
    front_temperature: 'Suhu Depan',
    rear_temperature: 'Suhu Belakang',
    temperature_1: 'Suhu 1',
    humidity_rh: 'Kelembapan (RH)',
    vpd_kpa: 'VPD (kPa)',
    first_trip: 'Perjalanan Pertama',
    current_location: 'Lokasi Semasa',
    table_view: 'Jadual',
    card_view: 'Kad',
    vpd: 'VPD',
    temperature_details: 'Butiran Suhu',
    real_time_compartment_temperature: 'Suhu Ruang Masa Nyata',
    door_sensor_analytics: 'Analitik Sensor Pintu',
    door_open_count: 'Bilangan Pintu Dibuka',
    total_open_time: 'Jumlah Masa Terbuka',
    door_activity_log: 'Log Aktiviti Pintu',
    door_events_same_hour: 'beberapa acara dalam jam yang sama',
    mold_risk: 'Risiko Kulat',
    mold_risk_level_very_high: 'Sangat Tinggi',
    mold_risk_level_high: 'Tinggi',
    mold_risk_level_moderate: 'Sederhana',
    mold_risk_level_low: 'Rendah',
    mold_risk_level_very_low: 'Sangat Rendah',
    mold_risk_level_none: 'Tiada',
    dew: 'Embun',
    temperature_configuration: 'Konfigurasi Suhu',
    max_temperature_celcius: 'Suhu Maks (°C)',
    min_temperature_celcius: 'Suhu Min (°C)',
    max_bold_risk_percentage: 'Risiko Tebal Maks (%)',
    last_24_hours: '24 Jam Terakhir',
    last_1_day: '1 Hari Terakhir',
    last_2_days: '2 Hari Terakhir',
    min_temperature: 'Suhu Min',
    max_temperature: 'Suhu Maks',
    avg_vpd: 'Purata VPD',
    avg_mold_risk: 'Purata Risiko Kulat',
    critical_threshold: 'Ambang Kritikal',
    avg_dew: 'Purata Embun',
    times: 'kali',
    secret_key: 'Kunci Rahasia',
    datetime_format_is_utc: 'Format tanggal waktu adalah UTC',
    once_closed_secret_cannot_be_reveal_anymore: 'Setelah ditutup, kunci rahasia tidak dapat dilihat lagi',
    are_you_sure_to_close: 'Apakah Anda yakin untuk menutup?',
    revoke: 'Batalkan',
    revoke_api_key: 'Batalkan Kunci API',
    are_you_sure_revoke: 'Apakah Anda yakin untuk membatalkan?',
    once_revoked_cannot_be_revoked_again: 'Setelah dibatalkan, tidak dapat dibatalkan lagi',
    revoke_api_key_success: 'Batalkan Kunci API Berhasil',
    created_api_key: 'Kunci API Dibuat',
    create_api_key: 'Cipta Kunci API',
    please_select_expiry_date: 'Sila pilih tarikh tamat',
    select_expiry_date_blank_for_no_expiry_date: 'Pilih tarikh tamat (kosong untuk tidak ada tarikh tamat)',
    create_new_api_key: 'Cipta Kunci API Baru',
    once_deleted_cannot_be_restored: 'Setelah dihapus, tidak dapat dipulihkan',
    delete_api_key: 'Padam Kunci API',
    delete_api_key_success: 'Padam Kunci API Berhasil',
    api_description: 'Penerangan API',
    updated_api_key: 'Kunci API Dikemas kini',
    update_api_key: 'Kemas kini Kunci API',
    update_api_key_success: 'Kemas kini Kunci API Berhasil',
    created_new_api_key: 'Kunci API Baru Dibuat',
    create_new_api_key_success: 'Cipta Kunci API Baru Berhasil',
    revoked: 'Ditolak',
    deleted_api_key: 'Kunci API Dihapus',
    secure_secret_key: 'Harap dicatat bahawa kunci rahasia tidak dapat diambil setelah sesi ini berakhir, jadi pastikan untuk menyimpannya selamat.',
    api_documentation: 'Dokumentasi API',
    temperature_report: 'Laporan Suhu',
    from_date_time: 'Dari Tanggal Waktu',
    to_date_time: 'Ke Tanggal Waktu',
    avg_temperature: 'Suhu Rata-rata',
    avg_temperature_2: 'Suhu Rata-rata 2',
    avg_temperature_3: 'Suhu Rata-rata 3',
    avg_temperature_4: 'Suhu Rata-rata 4',
    avg_humidity: 'Kelembaban Rata-rata',
    no_temperature_data: 'Perangkat ini tidak memiliki data suhu atau sensor yang diaktifkan',
    temperature_log: 'Log Suhu',
    overspeed_report: 'Laporan Kelajuan Terlalu Cepat',
    overspeed_duration: 'Durasi Kelajuan Terlalu Cepat',
    humidity: 'Kelembaban',
    pressure: 'Tekanan',
    pressure_2: 'Tekanan 2',
    cold_chain: 'Cold Chain',
    route_deviation_violation_report: 'Laporan Pelanggaran Deviasi Rute',
    route_deviation_instance: 'Instanci Deviasi Rute',
    unauthorized_violation_count: 'Pengesahan Tidak Diizinkan (Jumlah)',
    unauthorized_stop_count: 'Hentikan Tidak Diizinkan (Jumlah)',
    deviation_category: 'Kategori Deviasi',
    select_a_date: 'Pilih Tanggal',
    file_time: 'Waktu Berkas',
    download_center: 'Pusat Muat Turun',
    download_task: 'Tugas Unduh',
    download_task_already_exists: 'Tugas Unduh Sudah Ada',
    please_check_download_status_from: 'Sila semak status unduhan dari ',
    video_download_center: 'Pusat Muat Turun Video',
    download_started: 'Unduh Dimulai',
    download_failed: 'Unduh Gagal',
    request_failed: 'Permintaan Gagal',
    channel: 'Saluran',
    warning: 'Peringatan',
    operations: 'Operasi',
    file_size: 'Ukuran Berkas',
    task_start_time: 'Waktu Mulai Tugas',
    downloaded_time: 'Waktu Unduh',
    download_local: 'Unduh Lokal',
    download_not_completed: 'Unduh Tidak Selesai',
    redownload_task_begin: 'Tugas Muat Turun Semula Telah Dimulakan',
    schedule_download: 'Jadualkan Muat Turun',
    schedule: 'Jadualkan',
    schedule_multiple_channel_video_download_task: 'Jadualkan Tugas Muat Turun Video Berbilang Saluran',
    multiple_channel_download: 'Muat Turun Berbilang Saluran',
    notify_email: 'E-mel Pemberitahuan',
    audio_output: 'Output Audio',
    video_start_datetime: 'Tarikh Masa Mula Video',
    video_end_datetime: 'Tarikh Masa Tamat Video',
    please_enter_notify_email: 'Sila masukkan e-mel pemberitahuan',
    please_select_audio_output: 'Sila pilih output audio',
    please_select_at_least_one_channel: 'Sila pilih sekurang-kurangnya satu saluran',
    schedule_download_success: 'Tugas muat turun berjaya dijadualkan',
    schedule_download_failed: 'Gagal menjadualkan tugas muat turun',
    replay_video: 'Mainkan Video',
    maximize: 'Besarkan',
    restore: 'Pulihkan',
    video_replay: 'Rakaman Semula',
    all_channels: 'Semua Saluran',
    file_list: 'Senarai Fail',
    timeline: 'Garis Masa',
    evidence: 'Bukti',
    intercom_setting: 'Tetapan Intercom',
    select_one_intercom_type_to_communicate_with_the_driver: 'Pilih satu jenis intercom untuk berkomunikasi dengan pemandu',
    monitor: 'Monitor',
    monitoring: 'Mengawas...',
    talkback: 'Talkback',
    talking: 'Mengobrol...',
    stop: 'Berhenti',
    click_to_start_talking: 'Klik untuk mulai berkomunikasi',
    loading: 'Memuat...',
    intercom: 'Intercom',
    idling_streaming_duration: 'Tempoh Penstriman Melahu',
    idling_streaming_remaining: 'Baki masa penstriman melahu',
    idling_streaming_limit_reached: 'Had tempoh penstriman melahu telah dicapai',
    idling_streaming_reload_hint_before: 'Klik',
    idling_streaming_reload_hint_after: 'untuk teruskan penstriman video langsung',
    reload: 'Muat Semula',
    click_to_start_monitoring: 'Klik untuk memulai mengawas',
    invoice_date: 'Tarikh Invoice',
    open: 'Dibuka',
    in_progress: 'Sedang Berlangsung',
    closed: 'Ditutup',
    supplier_workshop: 'Workshop Penyedia',
    confirmation: 'Konfirmasi',
    confirm_reopen_status: 'Ubah Status Ditutup? Ini akan membuka catatan pemeliharaan dan perubahan akan disimpan.',
    status_update: 'Kemas Kini Status',
    fuel_calibration: 'Kalibrasi Bahan Api',
    delete_fuel_calibration: 'Padam Kalibrasi Bahan Api',
    update_fuel_calibration: 'Kemas Kini Kalibrasi Bahan Api',
    fuel_level_oil_resistance: 'Kelembapan Bahan Api (%) / Ketelusan Minyak (ohm)',
    min_tank_level: 'Kelembapan Tangki Minimum (%)',
    max_tank_level: 'Kelembapan Tangki Maksimum (%)',
    volume_l: 'Volume (L)',
    add_new_fuel_calibration: 'Tambah Kalibrasi Bahan Api Baru',
    tank: 'Tangki',
    tank_liter: 'Liter Tangki',
    min_fuel_percentage: 'Kecepatan Minyak Minimum',
    max_fuel_percentage: 'Kecepatan Minyak Maksimum',
    no_tracker_on_this_vehicle: 'Tidak ada penjejak pada kendaraan ini',
    no_duplicate_fuel_level: 'Jangan ada kelembapan Minyak duplikat',
    no_access: 'Tidak ada Akses',
    plate_no_asc: 'Plate No (ASC)',
    plate_no_desc: 'Plate No (DESC)',
    elock: 'ELock',
    updated_on: 'Diperbarui pada',
    view_fleet_details: 'Lihat Rincian Fleet',
    fleet_monitoring_board: 'Papan Pemuka Fleet',
    real_time_status_of_safevision_and_gps_assets: 'Status Sekarang Real dari Assets Safevision dan GPS',
    vehicle_offline: 'Kenderaan Tidak Dapat Dihubungkan',
    safevision_offline: 'Safevision Tidak Dapat Dihubungkan',
    storage_warning: 'Peringatan Penyimpanan',
    start_ai_analysis: 'Mulakan Analisis AI',
    offline_vehicle_monitor_more_than_12_hours: 'Pemantauan Offline Kenderaan (Lebih dari 12 jam)',
    filter_and_share_online_status_reports_for_client_troubleshooting: 'Saring dan Bagikan Laporan Status Online untuk Penyelesaian Masalah Klien',
    search_vehicle_or_fleet: 'Cari Kenderaan atau Fleet',
    server: 'Pelayan',
    power_volt: 'Daya/Volt',
    vehicle_plate_no: 'No Plat Kenderaan',
    location_address: 'Lokasi/Alamat',
    timestamp: 'Timestamp',
    copy_to_whatsapp: 'Salin ke Whatsapp',
    of_fleet: 'dari fleet',
    offline_gps_telematics: 'Offline GPS/Telematics',
    offline_safevision_mdvr: 'Offline Safevision/MDVR',
    last_seen: 'Terakhir Dilihat',
    device_name: 'Nama Peranti',
    handle_alert: 'Menangani Alert',
    critical_alerts_log: 'Log Alert Kritikal',
    active_storage_warnings: 'Peringatan Penyimpanan Aktif',
    requires_attention: 'Memerlukan Perhatian',
    memory_ssd_integrity: 'Integritas Memori/SSD',
    alert_type: 'Jenis Alert',
    message: 'Pesan',
    clear_all_alerts_log: 'Hapus Semua Log Alert?',
    clear_alerts_log_success: 'Berhasil Menghapus Log Alert',
    clear_alerts_log_cancel: 'Batal Penghapusan Log Alert',
    remove_this_alert: 'Hapus Alert Ini',
    remove_remark: 'Hapus Pernyataan',
    remove_alert_cancel: 'Batal Penghapusan Alert',
    accident_reconstruction_analysis_details: 'Rincian Analisis Reconstruction Accident',
    license_expiry: 'Kedaluwarsa Lisensi',
    impact_time: 'Waktu Kesan',
    accident_localization: 'Lokalisasi Accident',
    crash_reconstruction: 'Reconstruction Crash',
    accel_x: 'Accel X',
    accel_y: 'Accel Y',
    accel_z: 'Accel Z',
    x_g: 'X(G)',
    y_g: 'Y(G)',
    z_g: 'Z(G)',
    g_force: 'G Force',
    accident_logs: 'Log Accident',
    high_frequecy_telemetry_capture_1ms: 'Pengambilan Telemetri Tinggi Frekuensi (±1ms)',
    ms: 'MS',
    accident_reconstruction_analytics: 'Analisis Reconstruction Accident',
    fleet_wide_safety_performance_and_incident_monitoring: 'Fleet-wide Safety Performance and Incident Monitoring',
    fleet_safety_level: 'Fleet Safety Level',
    healthy_status: 'Healthy Status',
    active_vehicle: 'Active Vehicle',
    in_operation: 'In Operation',
    accident_count: 'Accident Count',
    verified_records: 'Verified Records',
    high_severity_rate: 'High Severity Rate',
    risk_alert: 'Risk Alert',
    incident_logs: 'Incident Logs',
    last_3_months: '3 bulan terakhir',
    last_12_months: '12 bulan terakhir',
    realtime_map_view: 'Paparan Peta Masa Nyata',
    safety_dashboard: 'Papan Pemuka Keselamatan',
    active_vehicles: 'Mobil Teraktif',
    accidents_count: 'Jumlah Kejadian',
    ivms_parameters: 'IVMS Parameters',
    driving_hour: 'Memandu Jam',
    continuos_driving_hour: 'Jam Berlangsung Memandu',
    planned_order_hour: 'Jam Pesanan Terjadwal',
    working_hour: 'Jam Bekerja',
    idle_duration_minute: 'Masa Tidak Bekerja (Minit)',
    unauthorized_stop_minute: 'Masa Hentikan Tidak Diizinkan (Minit)',
    rest_hour: 'Jam Berehat',
    lsr_violation_second: 'LSR Pelanggaran (Saat)',
    rest_break_every_x_hour: 'Rest Break Setiap N Jam',
    rest_break_minute: 'Rest Break (Menit)',
    change_same_shift_hour: 'Tukar/Shift yang Sama',
    working_hour_per_week: 'Jam Bekerja Per Seminggu',
    driving_hour_per_week: 'Jam Memandu Per Seminggu',
    gps_tracker_source: 'Sumber Penjejak GPS',
    default_source: 'Sumber Lalai',
    default_source_hint_default_title: 'Lalai',
    default_source_hint_default_primary: 'Menggunakan Periferal Utama jika tersedia.',
    default_source_hint_default_tracker: 'Jika tidak, menggunakan Penjejak.',
    default_source_hint_peripheral_priority_title: 'Keutamaan Periferal',
    default_source_hint_peripheral_priority_any: 'Menggunakan mana-mana Periferal (Utama atau Am) jika tersedia.',
    default_source_hint_peripheral_priority_tracker: 'Jika tidak, menggunakan Penjejak.',
    default_source_hint_peripheral_priority_fuel: 'Kecuali untuk laporan berkaitan Bahan Api (cth., Penggunaan Bahan Api, Ringkasan Kenderaan, dan Laporan ESG) sentiasa mengikut logik sumber Lalai.',
    over_speeding_highway_km_h: 'Lajukan Tinggi Lanjutan (Km/h)',
    over_speeding_highway_allowance_second: 'Lajukan Tinggi Lanjutan (Saat Tersedia)',
    over_speeding_non_highway_km_h: 'Lajukan Lain Lanjutan (Km/h)',
    over_speeding_non_highway_allowance_second: 'Lajukan Lain Lanjutan (Saat Tersedia)',
    lsr_violation_speed_km_h: 'Kelajuan LSR (Km/h)',
    harsh_acceleration_kmh_per_sec: 'Akselerasi Berat (Km/h/detik)',
    harsh_braking_kmh_per_sec: 'Brek Berat (Km/h/detik)',
    harsh_turning_cornering_g: 'Putaran Kelemahan Berat (G)',
    vehicle_id: 'ID Kenderaan',
    report_date: 'Tarikh Laporan',
    mileage_in_km: 'Jarak Perjalanan (KM)',
    total_data_count: 'Jumlah Data',
    not_located_percent: 'Peratusan Tidak Terletak (%)',
    network_disconnection_rate: 'Rata-rata Keputusan Jaringan',
    data_start_datetime: 'Tarikh Mula Data',
    data_end_datetime: 'Tarikh Akhir Data',
    reupload_count: 'Jumlah Ulang Muat Naik',
    search_terminal_or_vehicle: 'Cari Terminal atau Kenderaan',
    please_select_date_and_fleet_group: 'Sila pilih tarikh dan kumpulan armada',
    search_by_route_name: 'Cari mengikut Nama Laluan',
    route_name: 'Nama Laluan',
    route_color: 'Warna Laluan',
    route_radius: 'Jarak Laluan (m)',
    assignment: 'Penetapan',
    clear_and_replot: 'Hapus dan Tata-tata Laluan',
    delete_route: 'Padam Laluan',
    update_route: 'Kemas kini Laluan',
    create_route: 'Cipta Laluan',
    clustering: 'Penggabungan',
    labelling: 'Labelling',
    banner_image_management: 'Banner Image Management',
    edit_banner: 'Sunting Banner',
    display_date_range: 'Julat Tarikh Paparan',
    click_to_update_image: 'Klik untuk mengemas kini imej',
    upload_new_banner: 'Muat Naik Banner Baru',
    manage_dashboard_banner: 'Pengurusan Banner Papan Pemuka',
    preview: 'Pratonton',
    dimensions: 'Dimensi',
    uploaded_by: 'Diunggah Oleh',
    uploaded_at: 'Diunggah Pada',
    please_wait_for_the_vehicle_to_be_online_to_view: 'Sila tunggu untuk perkhidmatan dibuka untuk melihat',
    recent_trip_log: 'Log Perjalanan Terkini',
    playback: 'Main',
    driving_record: 'Rekod Kereta',
    from: 'Dari',
    to: 'Ke',
    trip_detail: 'Butiran Perjalanan',
    last_3_days: '3 Hari Terakhir',
    delete_banner_image: 'Imej banner dipadam',
    banner_image_title: 'Tajuk Imej Banner',
    confirm_delete: 'Sahkan Padam',
    please_leave_blank_for_using_the_default_vehicle: 'Sila tinggalkan kosong untuk menggunakan perkhidmatan lalai',
    choose_default_map_location: 'Pilih Lokasi Peta Lalai',
    default_map_location: 'Lokasi Peta Lalai',
    preset_regions: 'Kawasan Praset',
    speed_mileage_chart: 'Carta Kelajuan dan Perbatuan',
    show_log: 'Tunjukkan Log',
    hide_log: 'Sembunyikan Log',
}
